msgid ""
msgstr ""
"POT-Creation-Date: 2024-08-04 21:58+0800\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=UTF-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: de\n"
"Project-Id-Version: phanpy\n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: 2024-11-03 07:11\n"
"Last-Translator: \n"
"Language-Team: German\n"
"Plural-Forms: nplurals=2; plural=(n != 1);\n"
"X-Crowdin-Project: phanpy\n"
"X-Crowdin-Project-ID: 703337\n"
"X-Crowdin-Language: de\n"
"X-Crowdin-File: /main/src/locales/en.po\n"
"X-Crowdin-File-ID: 18\n"

#: src/components/account-block.jsx:135
msgid "Locked"
msgstr "Gesperrt"

#: src/components/account-block.jsx:141
msgid "Posts: {0}"
msgstr "Posts: {0}"

#: src/components/account-block.jsx:146
msgid "Last posted: {0}"
msgstr "Zuletzt gepostet: {0}"

#: src/components/account-block.jsx:161
#: src/components/account-info.jsx:634
msgid "Automated"
msgstr "Automatisiert"

#: src/components/account-block.jsx:168
#: src/components/account-info.jsx:639
#: src/components/status.jsx:498
msgid "Group"
msgstr "Gruppe"

#: src/components/account-block.jsx:178
msgid "Mutual"
msgstr "Befreundet"

#: src/components/account-block.jsx:182
#: src/components/account-info.jsx:1680
msgid "Requested"
msgstr "Angefragt"

#: src/components/account-block.jsx:186
#: src/components/account-info.jsx:1671
msgid "Following"
msgstr "Folgt"

#: src/components/account-block.jsx:190
#: src/components/account-info.jsx:1062
msgid "Follows you"
msgstr "Folgt Ihnen"

#: src/components/account-block.jsx:198
msgid "{followersCount, plural, one {# follower} other {# followers}}"
msgstr "{followersCount, plural, one {# Folgender} other {# Folgende}}"

#: src/components/account-block.jsx:207
#: src/components/account-info.jsx:680
msgid "Verified"
msgstr "Verifiziert"

#: src/components/account-block.jsx:222
#: src/components/account-info.jsx:780
msgid "Joined <0>{0}</0>"
msgstr "Beigetreten: <0>{0}</0>"

#: src/components/account-info.jsx:57
msgid "Forever"
msgstr "Für immer"

#: src/components/account-info.jsx:377
msgid "Unable to load account."
msgstr "Konto kann nicht geladen werden."

#: src/components/account-info.jsx:385
msgid "Go to account page"
msgstr "Zur Kontoseite gehen"

#: src/components/account-info.jsx:413
#: src/components/account-info.jsx:702
#: src/components/account-info.jsx:732
msgid "Followers"
msgstr "Folgende"

#. js-lingui-explicit-id
#: src/components/account-info.jsx:416
#: src/components/account-info.jsx:742
#: src/components/account-info.jsx:759
msgid "following.stats"
msgstr ""

#: src/components/account-info.jsx:419
#: src/components/account-info.jsx:776
#: src/pages/account-statuses.jsx:484
#: src/pages/search.jsx:312
#: src/pages/search.jsx:459
msgid "Posts"
msgstr "Beiträge"

#: src/components/account-info.jsx:427
#: src/components/account-info.jsx:1118
#: src/components/compose.jsx:2488
#: src/components/media-alt-modal.jsx:45
#: src/components/media-modal.jsx:283
#: src/components/status.jsx:1721
#: src/components/status.jsx:1738
#: src/components/status.jsx:1862
#: src/components/status.jsx:2474
#: src/components/status.jsx:2477
#: src/pages/account-statuses.jsx:528
#: src/pages/accounts.jsx:109
#: src/pages/hashtag.jsx:199
#: src/pages/list.jsx:157
#: src/pages/public.jsx:114
#: src/pages/status.jsx:1212
#: src/pages/trending.jsx:471
msgid "More"
msgstr "Mehr"

#: src/components/account-info.jsx:439
msgid "<0>{displayName}</0> has indicated that their new account is now:"
msgstr "<0>{displayName}</0> hat angegeben, dass sein/ihr neues Konto jetzt ist:"

#: src/components/account-info.jsx:584
#: src/components/account-info.jsx:1276
msgid "Handle copied"
msgstr "Handle kopiert"

#: src/components/account-info.jsx:587
#: src/components/account-info.jsx:1279
msgid "Unable to copy handle"
msgstr "Handle konnte nicht kopiert werden"

#: src/components/account-info.jsx:593
#: src/components/account-info.jsx:1285
msgid "Copy handle"
msgstr "Handle kopieren"

#: src/components/account-info.jsx:599
msgid "Go to original profile page"
msgstr "Zur ursprünglichen Profilseite gehen"

#: src/components/account-info.jsx:606
msgid "View profile image"
msgstr "Profilbild anzeigen"

#: src/components/account-info.jsx:612
msgid "View profile header"
msgstr "Profil-Header anzeigen"

#: src/components/account-info.jsx:629
msgid "In Memoriam"
msgstr ""

#: src/components/account-info.jsx:709
#: src/components/account-info.jsx:750
msgid "This user has chosen to not make this information available."
msgstr "Dieser Benutzer hat sich entschieden, diese Informationen nicht verfügbar zu machen."

#: src/components/account-info.jsx:805
msgid "{0} original posts, {1} replies, {2} boosts"
msgstr "{0} Originalbeiträge, {1} Antworten, {2} Boosts"

#: src/components/account-info.jsx:821
msgid "{0, plural, one {{1, plural, one {Last 1 post in the past 1 day} other {Last 1 post in the past {2} days}}} other {{3, plural, one {Last {4} posts in the past 1 day} other {Last {5} posts in the past {6} days}}}}"
msgstr "{0, plural, one {{1, plural, one {Letzter Beitrag des vergangenen Tags} other {Letzter Beitrag der vergangenen {2} Tage}}} other {{3, plural, one {Letzte {4} Beiträge des vergangenen Tags} other {Letzte {5} Beiträge der vergangenen {6} Tage}}}}"

#: src/components/account-info.jsx:834
msgid "{0, plural, one {Last 1 post in the past year(s)} other {Last {1} posts in the past year(s)}}"
msgstr "{0, plural, one {Letzter Beitrag des vergangenen Jahres} other {Letzter Beitrag der vergangenen {1} Jahre}}"

#: src/components/account-info.jsx:858
#: src/pages/catchup.jsx:70
msgid "Original"
msgstr "Original"

#: src/components/account-info.jsx:862
#: src/components/status.jsx:2252
#: src/pages/catchup.jsx:71
#: src/pages/catchup.jsx:1445
#: src/pages/catchup.jsx:2056
#: src/pages/status.jsx:935
#: src/pages/status.jsx:1557
msgid "Replies"
msgstr "Antworten"

#: src/components/account-info.jsx:866
#: src/pages/catchup.jsx:72
#: src/pages/catchup.jsx:1447
#: src/pages/catchup.jsx:2068
#: src/pages/settings.jsx:1110
msgid "Boosts"
msgstr "Boosts"

#: src/components/account-info.jsx:872
msgid "Post stats unavailable."
msgstr "Beitragsstatistiken nicht verfügbar."

#: src/components/account-info.jsx:903
msgid "View post stats"
msgstr "Beitragsstatistiken anzeigen"

#: src/components/account-info.jsx:1066
msgid "Last post: <0>{0}</0>"
msgstr "Letzter Beitrag: <0>{0}</0>"

#: src/components/account-info.jsx:1080
msgid "Muted"
msgstr "Stumm geschaltet"

#: src/components/account-info.jsx:1085
msgid "Blocked"
msgstr "Blockiert"

#: src/components/account-info.jsx:1094
msgid "Private note"
msgstr "Private Notiz"

#: src/components/account-info.jsx:1151
msgid "Mention <0>@{username}</0>"
msgstr ""

#: src/components/account-info.jsx:1163
msgid "Translate bio"
msgstr "Bio übersetzen"

#: src/components/account-info.jsx:1174
msgid "Edit private note"
msgstr "Private Notiz bearbeiten"

#: src/components/account-info.jsx:1174
msgid "Add private note"
msgstr "Private Notiz hinzufügen"

#: src/components/account-info.jsx:1194
msgid "Notifications enabled for @{username}'s posts."
msgstr "Benachrichtigungen für Beiträge von @{username} aktiviert."

#: src/components/account-info.jsx:1195
msgid "Notifications disabled for @{username}'s posts."
msgstr "Benachrichtigungen für Beiträge von @{username} deaktiviert."

#: src/components/account-info.jsx:1207
msgid "Disable notifications"
msgstr "Benachrichtigungen deaktivieren"

#: src/components/account-info.jsx:1208
msgid "Enable notifications"
msgstr "Benachrichtigungen aktivieren"

#: src/components/account-info.jsx:1225
msgid "Boosts from @{username} enabled."
msgstr "Boosts von @{username} aktiviert."

#: src/components/account-info.jsx:1226
msgid "Boosts from @{username} disabled."
msgstr "Boosts von @{username} deaktiviert."

#: src/components/account-info.jsx:1237
msgid "Disable boosts"
msgstr "Boosts deaktivieren"

#: src/components/account-info.jsx:1237
msgid "Enable boosts"
msgstr "Boosts aktivieren"

#: src/components/account-info.jsx:1253
#: src/components/account-info.jsx:1263
#: src/components/account-info.jsx:1864
msgid "Add/Remove from Lists"
msgstr "Hinzufügen/Entfernen aus Listen"

#: src/components/account-info.jsx:1302
#: src/components/status.jsx:1161
msgid "Link copied"
msgstr "Link kopiert"

#: src/components/account-info.jsx:1305
#: src/components/status.jsx:1164
msgid "Unable to copy link"
msgstr "Link konnte nicht kopiert werden"

#: src/components/account-info.jsx:1311
#: src/components/shortcuts-settings.jsx:1059
#: src/components/status.jsx:1170
#: src/components/status.jsx:3251
msgid "Copy"
msgstr "Kopieren"

#: src/components/account-info.jsx:1326
#: src/components/shortcuts-settings.jsx:1077
#: src/components/status.jsx:1186
msgid "Sharing doesn't seem to work."
msgstr "Teilen scheint nicht zu funktionieren."

#: src/components/account-info.jsx:1332
#: src/components/status.jsx:1192
msgid "Share…"
msgstr "Teilen…"

#: src/components/account-info.jsx:1352
msgid "Unmuted @{username}"
msgstr "Stummschaltung von @{username} aufgehoben"

#: src/components/account-info.jsx:1364
msgid "Unmute <0>@{username}</0>"
msgstr ""

#: src/components/account-info.jsx:1380
msgid "Mute <0>@{username}</0>…"
msgstr ""

#: src/components/account-info.jsx:1412
msgid "Muted @{username} for {0}"
msgstr "@{username} für {0} Stumm geschaltet"

#: src/components/account-info.jsx:1424
msgid "Unable to mute @{username}"
msgstr "Konnte @{username} nicht stumm schalten"

#: src/components/account-info.jsx:1445
msgid "Remove <0>@{username}</0> from followers?"
msgstr ""

#: src/components/account-info.jsx:1465
msgid "@{username} removed from followers"
msgstr "@{username} von Folgenden entfernt"

#: src/components/account-info.jsx:1477
msgid "Remove follower…"
msgstr "Folgenden entfernen…"

#: src/components/account-info.jsx:1488
msgid "Block <0>@{username}</0>?"
msgstr ""

#: src/components/account-info.jsx:1512
msgid "Unblocked @{username}"
msgstr "@{username} entsperrt"

#: src/components/account-info.jsx:1520
msgid "Blocked @{username}"
msgstr "@{username} blockiert"

#: src/components/account-info.jsx:1528
msgid "Unable to unblock @{username}"
msgstr "@{username} kann nicht entsperrt werden"

#: src/components/account-info.jsx:1530
msgid "Unable to block @{username}"
msgstr "Konnte @{username} nicht blockieren"

#: src/components/account-info.jsx:1540
msgid "Unblock <0>@{username}</0>"
msgstr ""

#: src/components/account-info.jsx:1549
msgid "Block <0>@{username}</0>…"
msgstr ""

#: src/components/account-info.jsx:1566
msgid "Report <0>@{username}</0>…"
msgstr ""

#: src/components/account-info.jsx:1586
#: src/components/account-info.jsx:2097
msgid "Edit profile"
msgstr "Profil bearbeiten"

#: src/components/account-info.jsx:1622
msgid "Withdraw follow request?"
msgstr "Folgeanfrage zurückziehen?"

#: src/components/account-info.jsx:1623
msgid "Unfollow @{0}?"
msgstr "@{0} entfolgen?"

#: src/components/account-info.jsx:1674
msgid "Unfollow…"
msgstr "Entfolgen…"

#: src/components/account-info.jsx:1683
msgid "Withdraw…"
msgstr "Zurückziehen…"

#: src/components/account-info.jsx:1690
#: src/components/account-info.jsx:1694
#: src/pages/hashtag.jsx:261
msgid "Follow"
msgstr "Folgen"

#: src/components/account-info.jsx:1805
#: src/components/account-info.jsx:1859
#: src/components/account-info.jsx:1992
#: src/components/account-info.jsx:2092
#: src/components/account-sheet.jsx:37
#: src/components/compose.jsx:818
#: src/components/compose.jsx:2444
#: src/components/compose.jsx:2917
#: src/components/compose.jsx:3125
#: src/components/compose.jsx:3355
#: src/components/drafts.jsx:58
#: src/components/embed-modal.jsx:12
#: src/components/generic-accounts.jsx:142
#: src/components/keyboard-shortcuts-help.jsx:39
#: src/components/list-add-edit.jsx:33
#: src/components/media-alt-modal.jsx:33
#: src/components/media-modal.jsx:247
#: src/components/notification-service.jsx:156
#: src/components/report-modal.jsx:75
#: src/components/shortcuts-settings.jsx:230
#: src/components/shortcuts-settings.jsx:583
#: src/components/shortcuts-settings.jsx:783
#: src/components/status.jsx:2976
#: src/components/status.jsx:3215
#: src/components/status.jsx:3713
#: src/pages/accounts.jsx:36
#: src/pages/catchup.jsx:1581
#: src/pages/filters.jsx:224
#: src/pages/list.jsx:274
#: src/pages/notifications.jsx:868
#: src/pages/notifications.jsx:1082
#: src/pages/settings.jsx:76
#: src/pages/status.jsx:1299
msgid "Close"
msgstr "Schließen"

#: src/components/account-info.jsx:1810
msgid "Translated Bio"
msgstr "Übersetzte Bio"

#: src/components/account-info.jsx:1904
msgid "Unable to remove from list."
msgstr "Konnte nicht von der Liste entfernt werden."

#: src/components/account-info.jsx:1905
msgid "Unable to add to list."
msgstr "Konnte nicht zur Liste hinzugefügt werden."

#: src/components/account-info.jsx:1924
#: src/pages/lists.jsx:104
msgid "Unable to load lists."
msgstr "Listen konnten nicht geladen werden."

#: src/components/account-info.jsx:1928
msgid "No lists."
msgstr "Keine Listen."

#: src/components/account-info.jsx:1939
#: src/components/list-add-edit.jsx:37
#: src/pages/lists.jsx:58
msgid "New list"
msgstr "Neue Liste"

#: src/components/account-info.jsx:1997
msgid "Private note about <0>@{0}</0>"
msgstr ""

#: src/components/account-info.jsx:2027
msgid "Unable to update private note."
msgstr "Private Notiz konnte nicht aktualisiert werden."

#: src/components/account-info.jsx:2050
#: src/components/account-info.jsx:2220
msgid "Cancel"
msgstr "Abbrechen"

#: src/components/account-info.jsx:2055
msgid "Save & close"
msgstr "Speichern & schließen"

#: src/components/account-info.jsx:2148
msgid "Unable to update profile."
msgstr "Profil konnte nicht aktualisiert werden."

#: src/components/account-info.jsx:2155
#: src/components/list-add-edit.jsx:102
msgid "Name"
msgstr "Name"

#: src/components/account-info.jsx:2168
msgid "Bio"
msgstr "Bio"

#: src/components/account-info.jsx:2181
msgid "Extra fields"
msgstr "Zusätzliche Felder"

#: src/components/account-info.jsx:2187
msgid "Label"
msgstr "Label"

#: src/components/account-info.jsx:2190
msgid "Content"
msgstr "Inhalt"

#: src/components/account-info.jsx:2223
#: src/components/list-add-edit.jsx:147
#: src/components/shortcuts-settings.jsx:715
#: src/pages/filters.jsx:554
#: src/pages/notifications.jsx:934
msgid "Save"
msgstr "Speichern"

#: src/components/account-info.jsx:2276
msgid "username"
msgstr "Benutzername"

#: src/components/account-info.jsx:2280
msgid "server domain name"
msgstr "Server-Domainname"

#: src/components/background-service.jsx:149
msgid "Cloak mode disabled"
msgstr "Cloak-Modus deaktiviert"

#: src/components/background-service.jsx:149
msgid "Cloak mode enabled"
msgstr "Cloak-Modus aktiviert"

#: src/components/columns.jsx:26
#: src/components/nav-menu.jsx:184
#: src/components/shortcuts-settings.jsx:139
#: src/components/timeline.jsx:437
#: src/pages/catchup.jsx:876
#: src/pages/filters.jsx:89
#: src/pages/followed-hashtags.jsx:40
#: src/pages/home.jsx:53
#: src/pages/notifications.jsx:520
msgid "Home"
msgstr "Startseite"

#: src/components/compose-button.jsx:49
#: src/compose.jsx:37
msgid "Compose"
msgstr "Verfassen"

#: src/components/compose.jsx:394
msgid "You have unsaved changes. Discard this post?"
msgstr "Sie haben ungespeicherte Änderungen. Diesen Beitrag verwerfen?"

#: src/components/compose.jsx:622
msgid "{0, plural, one {File {1} is not supported.} other {Files {2} are not supported.}}"
msgstr ""

#: src/components/compose.jsx:632
#: src/components/compose.jsx:650
#: src/components/compose.jsx:1361
#: src/components/compose.jsx:1623
msgid "{maxMediaAttachments, plural, one {You can only attach up to 1 file.} other {You can only attach up to # files.}}"
msgstr "{maxMediaAttachments, plural, one {Du kannst höchstens eine Datei anhängen.} other {Du kannst höchstens # Dateien anhängen.}}"

#: src/components/compose.jsx:799
msgid "Pop out"
msgstr "Herauslösen"

#: src/components/compose.jsx:806
msgid "Minimize"
msgstr "Minimieren"

#: src/components/compose.jsx:842
msgid "Looks like you closed the parent window."
msgstr "Es sieht so aus, als ob Sie das übergeordnete Fenster geschlossen hätten."

#: src/components/compose.jsx:849
msgid "Looks like you already have a compose field open in the parent window and currently publishing. Please wait for it to be done and try again later."
msgstr "Es sieht so aus, als ob Sie bereits ein Verfassen-Feld im übergeordneten Fenster geöffnet haben und gerade veröffentlichen. Bitte warten Sie, bis es fertig ist, und versuchen Sie es später erneut."

#: src/components/compose.jsx:854
msgid "Looks like you already have a compose field open in the parent window. Popping in this window will discard the changes you made in the parent window. Continue?"
msgstr "Es sieht so aus, als hätten Sie bereits ein Verfassen-Feld im übergeordneten Fenster geöffnet. Wenn Sie dieses Fenster einblenden, werden die Änderungen, die Sie im übergeordneten Fenster vorgenommen haben, verworfen. Fortfahren?"

#: src/components/compose.jsx:896
msgid "Pop in"
msgstr "Einblenden"

#: src/components/compose.jsx:906
msgid "Replying to @{0}’s post (<0>{1}</0>)"
msgstr "Als Antwort auf den Beitrag von @{0} (<0>{1}</0>)"

#: src/components/compose.jsx:916
msgid "Replying to @{0}’s post"
msgstr "Als Antwort auf den Beitrag von @{0}"

#: src/components/compose.jsx:929
msgid "Editing source post"
msgstr "Quellbeitrag bearbeiten"

#: src/components/compose.jsx:976
msgid "Poll must have at least 2 options"
msgstr "Umfrage muss mindestens 2 Optionen enthalten"

#: src/components/compose.jsx:980
msgid "Some poll choices are empty"
msgstr "Einige Umfrageoptionen sind leer"

#: src/components/compose.jsx:993
msgid "Some media have no descriptions. Continue?"
msgstr "Einige Medien haben keine Beschreibungen. Fortfahren?"

#: src/components/compose.jsx:1045
msgid "Attachment #{i} failed"
msgstr "Anhang #{i} fehlgeschlagen"

#: src/components/compose.jsx:1139
#: src/components/status.jsx:2047
#: src/components/timeline.jsx:984
msgid "Content warning"
msgstr "Inhaltswarnung"

#: src/components/compose.jsx:1155
msgid "Content warning or sensitive media"
msgstr "Inhaltswarnung oder sensible Medien"

#: src/components/compose.jsx:1191
#: src/components/status.jsx:93
#: src/pages/settings.jsx:304
msgid "Public"
msgstr "Öffentlich"

#: src/components/compose.jsx:1196
#: src/components/nav-menu.jsx:386
#: src/components/shortcuts-settings.jsx:165
#: src/components/status.jsx:94
msgid "Local"
msgstr "Lokal"

#: src/components/compose.jsx:1200
#: src/components/status.jsx:95
#: src/pages/settings.jsx:307
msgid "Unlisted"
msgstr "Nicht gelistet"

#: src/components/compose.jsx:1203
#: src/components/status.jsx:96
#: src/pages/settings.jsx:310
msgid "Followers only"
msgstr "Nur für Folgende"

#: src/components/compose.jsx:1206
#: src/components/status.jsx:97
#: src/components/status.jsx:1925
msgid "Private mention"
msgstr "Private Erwähnung"

#: src/components/compose.jsx:1215
msgid "Post your reply"
msgstr "Antwort veröffentlichen"

#: src/components/compose.jsx:1217
msgid "Edit your post"
msgstr "Post bearbeiten"

#: src/components/compose.jsx:1218
msgid "What are you doing?"
msgstr "Was machen Sie?"

#: src/components/compose.jsx:1296
msgid "Mark media as sensitive"
msgstr "Medien als sensibel markieren"

#: src/components/compose.jsx:1397
msgid "Add poll"
msgstr "Umfrage hinzufügen"

#: src/components/compose.jsx:1419
msgid "Add custom emoji"
msgstr "Benutzerdefinierte Emoji hinzufügen"

#: src/components/compose.jsx:1504
#: src/components/keyboard-shortcuts-help.jsx:151
#: src/components/status.jsx:913
#: src/components/status.jsx:1701
#: src/components/status.jsx:1702
#: src/components/status.jsx:2370
msgid "Reply"
msgstr "Antworten"

#: src/components/compose.jsx:1506
msgid "Update"
msgstr "Aktualisieren"

#: src/components/compose.jsx:1507
msgctxt "Submit button in composer"
msgid "Post"
msgstr ""

#: src/components/compose.jsx:1635
msgid "Downloading GIF…"
msgstr "GIF wird heruntergeladen…"

#: src/components/compose.jsx:1663
msgid "Failed to download GIF"
msgstr "GIF konnte nicht heruntergeladen werden"

#: src/components/compose.jsx:1775
#: src/components/compose.jsx:1852
#: src/components/nav-menu.jsx:287
msgid "More…"
msgstr "Mehr…"

#: src/components/compose.jsx:2257
msgid "Uploaded"
msgstr "Hochgeladen"

#: src/components/compose.jsx:2270
msgid "Image description"
msgstr "Bildbeschreibung"

#: src/components/compose.jsx:2271
msgid "Video description"
msgstr "Videobeschreibung"

#: src/components/compose.jsx:2272
msgid "Audio description"
msgstr "Audiobeschreibung"

#: src/components/compose.jsx:2308
#: src/components/compose.jsx:2328
msgid "File size too large. Uploading might encounter issues. Try reduce the file size from {0} to {1} or lower."
msgstr "Datei zu groß. Das Hochladen kann Probleme verursachen. Versuche, die Dateigröße von {0} auf {1} oder weniger zu reduzieren."

#: src/components/compose.jsx:2320
#: src/components/compose.jsx:2340
msgid "Dimension too large. Uploading might encounter issues. Try reduce dimension from {0}×{1}px to {2}×{3}px."
msgstr "Auflösung zu groß. Das Hochladen könnte Probleme verursachen. Versuche, das Seitenverhältnis von {0}×{1} px auf {2}×{3} px zu reduzieren."

#: src/components/compose.jsx:2348
msgid "Frame rate too high. Uploading might encounter issues."
msgstr "Bildrate zu hoch. Das Hochladen könnte Probleme verursachen."

#: src/components/compose.jsx:2408
#: src/components/compose.jsx:2658
#: src/components/shortcuts-settings.jsx:726
#: src/pages/catchup.jsx:1074
#: src/pages/filters.jsx:412
msgid "Remove"
msgstr "Entfernen"

#: src/components/compose.jsx:2425
#: src/compose.jsx:83
msgid "Error"
msgstr "Fehler"

#: src/components/compose.jsx:2450
msgid "Edit image description"
msgstr "Bildbeschreibung bearbeiten"

#: src/components/compose.jsx:2451
msgid "Edit video description"
msgstr "Videobeschreibung bearbeiten"

#: src/components/compose.jsx:2452
msgid "Edit audio description"
msgstr "Audiobeschreibung bearbeiten"

#: src/components/compose.jsx:2497
#: src/components/compose.jsx:2546
msgid "Generating description. Please wait…"
msgstr "Erzeuge Beschreibung. Bitte warten Sie…"

#: src/components/compose.jsx:2517
msgid "Failed to generate description: {0}"
msgstr "Fehler beim Erzeugen der Beschreibung: {0}"

#: src/components/compose.jsx:2518
msgid "Failed to generate description"
msgstr "Beschreibung konnte nicht erzeugt werden"

#: src/components/compose.jsx:2530
#: src/components/compose.jsx:2536
#: src/components/compose.jsx:2582
msgid "Generate description…"
msgstr "Beschreibung erzeugen…"

#: src/components/compose.jsx:2569
msgid "Failed to generate description{0}"
msgstr "Fehler beim Erzeugen der Beschreibung{0}"

#: src/components/compose.jsx:2584
msgid "({0}) <0>— experimental</0>"
msgstr "({0}) <0>– experimentell</0>"

#: src/components/compose.jsx:2603
msgid "Done"
msgstr "Fertig"

#: src/components/compose.jsx:2639
msgid "Choice {0}"
msgstr "Auswahl {0}"

#: src/components/compose.jsx:2686
msgid "Multiple choices"
msgstr "Mehrfache Auswahl"

#: src/components/compose.jsx:2689
msgid "Duration"
msgstr "Dauer"

#: src/components/compose.jsx:2720
msgid "Remove poll"
msgstr "Umfrage entfernen"

#: src/components/compose.jsx:2934
msgid "Search accounts"
msgstr "Konten suchen"

#: src/components/compose.jsx:2975
#: src/components/shortcuts-settings.jsx:715
#: src/pages/list.jsx:359
msgid "Add"
msgstr "Hinzufügen"

#: src/components/compose.jsx:2988
#: src/components/generic-accounts.jsx:227
msgid "Error loading accounts"
msgstr "Fehler beim Laden der Konten"

#: src/components/compose.jsx:3131
msgid "Custom emojis"
msgstr "Benutzerdefinierte Emojis"

#: src/components/compose.jsx:3151
msgid "Search emoji"
msgstr "Emoji suchen"

#: src/components/compose.jsx:3182
msgid "Error loading custom emojis"
msgstr "Fehler beim Laden benutzerdefinierter Emojis"

#: src/components/compose.jsx:3193
msgid "Recently used"
msgstr "Zuletzt verwendet"

#: src/components/compose.jsx:3194
msgid "Others"
msgstr "Andere"

#: src/components/compose.jsx:3232
msgid "{0} more…"
msgstr "{0} mehr…"

#: src/components/compose.jsx:3370
msgid "Search GIFs"
msgstr "GIFs suchen"

#: src/components/compose.jsx:3385
msgid "Powered by GIPHY"
msgstr "Ermöglicht durch GIPHY"

#: src/components/compose.jsx:3393
msgid "Type to search GIFs"
msgstr "Eintippen, um GIFs zu suchen"

#: src/components/compose.jsx:3491
#: src/components/media-modal.jsx:387
#: src/components/timeline.jsx:889
msgid "Previous"
msgstr "Zurück"

#: src/components/compose.jsx:3509
#: src/components/media-modal.jsx:406
#: src/components/timeline.jsx:906
msgid "Next"
msgstr "Weiter"

#: src/components/compose.jsx:3526
msgid "Error loading GIFs"
msgstr "Fehler beim Laden der GIFs"

#: src/components/drafts.jsx:63
#: src/pages/settings.jsx:691
msgid "Unsent drafts"
msgstr "Nicht gesendete Entwürfe"

#: src/components/drafts.jsx:68
msgid "Looks like you have unsent drafts. Let's continue where you left off."
msgstr "Es sieht so aus, als hätten Sie noch nicht gesendete Entwürfe. Lass uns dort fortfahren, wo Sie aufgehört haben."

#: src/components/drafts.jsx:102
msgid "Delete this draft?"
msgstr "Diesen Entwurf löschen?"

#: src/components/drafts.jsx:117
msgid "Error deleting draft! Please try again."
msgstr "Fehler beim Löschen des Entwurfs! Bitte versuchen Sie es erneut."

#: src/components/drafts.jsx:127
#: src/components/list-add-edit.jsx:183
#: src/components/status.jsx:1336
#: src/pages/filters.jsx:587
msgid "Delete…"
msgstr "Löschen…"

#: src/components/drafts.jsx:146
msgid "Error fetching reply-to status!"
msgstr "Fehler beim Abrufen des Antwort-zu-Statuses!"

#: src/components/drafts.jsx:171
msgid "Delete all drafts?"
msgstr "Alle Entwürfe löschen?"

#: src/components/drafts.jsx:189
msgid "Error deleting drafts! Please try again."
msgstr "Fehler beim Löschen der Entwürfe! Bitte versuchen Sie es erneut."

#: src/components/drafts.jsx:201
msgid "Delete all…"
msgstr "Alle löschen…"

#: src/components/drafts.jsx:209
msgid "No drafts found."
msgstr "Keine Entwürfe gefunden."

#: src/components/drafts.jsx:245
#: src/pages/catchup.jsx:1928
msgid "Poll"
msgstr "Umfrage"

#: src/components/drafts.jsx:248
#: src/pages/account-statuses.jsx:365
msgid "Media"
msgstr "Medien"

#: src/components/embed-modal.jsx:22
msgid "Open in new window"
msgstr "In neuem Fenster öffnen"

#: src/components/follow-request-buttons.jsx:42
#: src/pages/notifications.jsx:918
msgid "Accept"
msgstr "Akzeptieren"

#: src/components/follow-request-buttons.jsx:68
msgid "Reject"
msgstr "Ablehnen"

#: src/components/follow-request-buttons.jsx:75
#: src/pages/notifications.jsx:1201
msgid "Accepted"
msgstr "Akzeptiert"

#: src/components/follow-request-buttons.jsx:79
msgid "Rejected"
msgstr "Abgelehnt"

#: src/components/generic-accounts.jsx:24
msgid "Nothing to show"
msgstr "Nichts anzuzeigen"

#: src/components/generic-accounts.jsx:145
#: src/components/notification.jsx:438
#: src/pages/accounts.jsx:41
#: src/pages/search.jsx:302
#: src/pages/search.jsx:335
msgid "Accounts"
msgstr "Konten"

#: src/components/generic-accounts.jsx:205
#: src/components/timeline.jsx:519
#: src/pages/list.jsx:293
#: src/pages/notifications.jsx:848
#: src/pages/search.jsx:529
#: src/pages/status.jsx:1332
msgid "Show more…"
msgstr "Mehr anzeigen…"

#: src/components/generic-accounts.jsx:210
#: src/components/timeline.jsx:524
#: src/pages/search.jsx:534
msgid "The end."
msgstr "Das Ende."

#: src/components/keyboard-shortcuts-help.jsx:43
#: src/components/nav-menu.jsx:405
#: src/pages/catchup.jsx:1619
msgid "Keyboard shortcuts"
msgstr "Tastenkombinationen"

#: src/components/keyboard-shortcuts-help.jsx:51
msgid "Keyboard shortcuts help"
msgstr "Hilfe zu Tastenkombinationen"

#: src/components/keyboard-shortcuts-help.jsx:55
#: src/pages/catchup.jsx:1644
msgid "Next post"
msgstr "Nächster Post"

#: src/components/keyboard-shortcuts-help.jsx:59
#: src/pages/catchup.jsx:1652
msgid "Previous post"
msgstr "Vorheriger Post"

#: src/components/keyboard-shortcuts-help.jsx:63
msgid "Skip carousel to next post"
msgstr "Karussell zum nächsten Post überspringen"

#: src/components/keyboard-shortcuts-help.jsx:65
msgid "<0>Shift</0> + <1>j</1>"
msgstr "<0>Umschalt</0> + <1>j</1>"

#: src/components/keyboard-shortcuts-help.jsx:71
msgid "Skip carousel to previous post"
msgstr "Karussell zum vorherigen Post überspringen"

#: src/components/keyboard-shortcuts-help.jsx:73
msgid "<0>Shift</0> + <1>k</1>"
msgstr "<0>Umschalt</0> + <1>k</1>"

#: src/components/keyboard-shortcuts-help.jsx:79
msgid "Load new posts"
msgstr "Neue Posts laden"

#: src/components/keyboard-shortcuts-help.jsx:83
#: src/pages/catchup.jsx:1676
msgid "Open post details"
msgstr "Postdetails öffnen"

#: src/components/keyboard-shortcuts-help.jsx:85
msgid "<0>Enter</0> or <1>o</1>"
msgstr "<0>Eingabe</0> oder <1>o</1>"

#: src/components/keyboard-shortcuts-help.jsx:92
msgid "Expand content warning or<0/>toggle expanded/collapsed thread"
msgstr "Inhaltswarnung ausklappen oder<0/>aus-/eingeklappte Unterhaltung umschalten"

#: src/components/keyboard-shortcuts-help.jsx:101
msgid "Close post or dialogs"
msgstr "Post oder Dialoge schließen"

#: src/components/keyboard-shortcuts-help.jsx:103
msgid "<0>Esc</0> or <1>Backspace</1>"
msgstr "<0>Esc</0> oder <1>Löschtaste</1>"

#: src/components/keyboard-shortcuts-help.jsx:109
msgid "Focus column in multi-column mode"
msgstr "Spalte im mehrspaltigen Modus fokussieren"

#: src/components/keyboard-shortcuts-help.jsx:111
msgid "<0>1</0> to <1>9</1>"
msgstr "<0>1</0> bis <1>9</1>"

#: src/components/keyboard-shortcuts-help.jsx:117
msgid "Focus next column in multi-column mode"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:121
msgid "Focus previous column in multi-column mode"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:125
msgid "Compose new post"
msgstr "Neuen Post erstellen"

#: src/components/keyboard-shortcuts-help.jsx:129
msgid "Compose new post (new window)"
msgstr "Neuen Post erstellen (neues Fenster)"

#: src/components/keyboard-shortcuts-help.jsx:132
msgid "<0>Shift</0> + <1>c</1>"
msgstr "<0>Umschalt</0> + <1>c</1>"

#: src/components/keyboard-shortcuts-help.jsx:138
msgid "Send post"
msgstr "Post senden"

#: src/components/keyboard-shortcuts-help.jsx:140
msgid "<0>Ctrl</0> + <1>Enter</1> or <2>⌘</2> + <3>Enter</3>"
msgstr "<0>Strg</0> + <1>Eingabe</1> oder <2>⌘</2> + <3>Eingabe</3>"

#: src/components/keyboard-shortcuts-help.jsx:147
#: src/components/nav-menu.jsx:374
#: src/components/search-form.jsx:72
#: src/components/shortcuts-settings.jsx:52
#: src/components/shortcuts-settings.jsx:179
#: src/pages/search.jsx:45
#: src/pages/search.jsx:284
msgid "Search"
msgstr "Suchen"

#: src/components/keyboard-shortcuts-help.jsx:155
msgid "Reply (new window)"
msgstr "Antworten (neues Fenster)"

#: src/components/keyboard-shortcuts-help.jsx:158
msgid "<0>Shift</0> + <1>r</1>"
msgstr "<0>Umschalt</0> + <1>r</1>"

#: src/components/keyboard-shortcuts-help.jsx:164
msgid "Like (favourite)"
msgstr "Liken (favorisieren)"

#: src/components/keyboard-shortcuts-help.jsx:166
msgid "<0>l</0> or <1>f</1>"
msgstr "<0>l</0> oder <1>f</1>"

#: src/components/keyboard-shortcuts-help.jsx:172
#: src/components/status.jsx:921
#: src/components/status.jsx:2396
#: src/components/status.jsx:2428
#: src/components/status.jsx:2429
msgid "Boost"
msgstr "Boosten"

#: src/components/keyboard-shortcuts-help.jsx:174
msgid "<0>Shift</0> + <1>b</1>"
msgstr "<0>Umschalt</0> + <1>b</1>"

#: src/components/keyboard-shortcuts-help.jsx:180
#: src/components/status.jsx:1006
#: src/components/status.jsx:2453
#: src/components/status.jsx:2454
msgid "Bookmark"
msgstr "Lesezeichen"

#: src/components/keyboard-shortcuts-help.jsx:184
msgid "Toggle Cloak mode"
msgstr "Cloak Modus ein/aus"

#: src/components/keyboard-shortcuts-help.jsx:186
msgid "<0>Shift</0> + <1>Alt</1> + <2>k</2>"
msgstr "<0>Umschalt</0> + <1>Alt</1> + <2>k</2>"

#: src/components/list-add-edit.jsx:37
msgid "Edit list"
msgstr "Liste bearbeiten"

#: src/components/list-add-edit.jsx:93
msgid "Unable to edit list."
msgstr "Liste konnte nicht bearbeitet werden."

#: src/components/list-add-edit.jsx:94
msgid "Unable to create list."
msgstr "Liste konnte nicht erstellt werden."

#: src/components/list-add-edit.jsx:122
msgid "Show replies to list members"
msgstr "Antworten auf Listenmitglieder anzeigen"

#: src/components/list-add-edit.jsx:125
msgid "Show replies to people I follow"
msgstr "Antworten auf Personen denen ich folge anzeigen"

#: src/components/list-add-edit.jsx:128
msgid "Don't show replies"
msgstr "Antworten nicht anzeigen"

#: src/components/list-add-edit.jsx:141
msgid "Hide posts on this list from Home/Following"
msgstr ""

#: src/components/list-add-edit.jsx:147
#: src/pages/filters.jsx:554
msgid "Create"
msgstr "Erstellen"

#: src/components/list-add-edit.jsx:154
msgid "Delete this list?"
msgstr "Diese Liste löschen?"

#: src/components/list-add-edit.jsx:173
msgid "Unable to delete list."
msgstr "Liste konnte nicht gelöscht werden."

#: src/components/media-alt-modal.jsx:38
#: src/components/media.jsx:50
msgid "Media description"
msgstr "Medienbeschreibung"

#: src/components/media-alt-modal.jsx:57
#: src/components/status.jsx:1050
#: src/components/status.jsx:1077
#: src/components/translation-block.jsx:195
msgid "Translate"
msgstr "Übersetzen"

#: src/components/media-alt-modal.jsx:68
#: src/components/status.jsx:1064
#: src/components/status.jsx:1091
msgid "Speak"
msgstr "Sprechen"

#: src/components/media-modal.jsx:294
msgid "Open original media in new window"
msgstr "Originalmedien in neuem Fenster öffnen"

#: src/components/media-modal.jsx:298
msgid "Open original media"
msgstr "Originalmedien öffnen"

#: src/components/media-modal.jsx:314
msgid "Attempting to describe image. Please wait…"
msgstr "Es wird versucht, das Bild zu beschreiben. Bitte warten Sie…"

#: src/components/media-modal.jsx:329
msgid "Failed to describe image"
msgstr "Fehler beim Beschreiben des Bildes"

#: src/components/media-modal.jsx:339
msgid "Describe image…"
msgstr "Beschreibe Bild…"

#: src/components/media-modal.jsx:362
msgid "View post"
msgstr "Post anzeigen"

#: src/components/media-post.jsx:127
msgid "Sensitive media"
msgstr "Sensible Medien"

#: src/components/media-post.jsx:132
msgid "Filtered: {filterTitleStr}"
msgstr "Gefiltert: {filterTitleStr}"

#: src/components/media-post.jsx:133
#: src/components/status.jsx:3543
#: src/components/status.jsx:3639
#: src/components/status.jsx:3717
#: src/components/timeline.jsx:973
#: src/pages/catchup.jsx:75
#: src/pages/catchup.jsx:1876
msgid "Filtered"
msgstr "Gefiltert"

#: src/components/modals.jsx:72
msgid "Post published. Check it out."
msgstr "Post veröffentlicht. Schauen Sie sich ihn an."

#: src/components/modals.jsx:73
msgid "Reply posted. Check it out."
msgstr "Antwort gepostet. Schauen Sie sich sie an."

#: src/components/modals.jsx:74
msgid "Post updated. Check it out."
msgstr "Post aktualisiert. Schauen Sie sich ihn an."

#: src/components/nav-menu.jsx:126
msgid "Menu"
msgstr "Menü"

#: src/components/nav-menu.jsx:162
msgid "Reload page now to update?"
msgstr "Seite jetzt neu laden um zu aktualisieren?"

#: src/components/nav-menu.jsx:174
msgid "New update available…"
msgstr "Neues Update verfügbar…"

#. js-lingui-explicit-id
#: src/components/nav-menu.jsx:193
#: src/components/shortcuts-settings.jsx:140
#: src/pages/following.jsx:22
#: src/pages/following.jsx:141
msgid "following.title"
msgstr ""

#: src/components/nav-menu.jsx:200
#: src/pages/catchup.jsx:871
msgid "Catch-up"
msgstr "Aufholen"

#: src/components/nav-menu.jsx:207
#: src/components/shortcuts-settings.jsx:58
#: src/components/shortcuts-settings.jsx:146
#: src/pages/home.jsx:224
#: src/pages/mentions.jsx:20
#: src/pages/mentions.jsx:167
#: src/pages/settings.jsx:1102
#: src/pages/trending.jsx:381
msgid "Mentions"
msgstr "Erwähnungen"

#: src/components/nav-menu.jsx:214
#: src/components/shortcuts-settings.jsx:49
#: src/components/shortcuts-settings.jsx:152
#: src/pages/filters.jsx:24
#: src/pages/home.jsx:84
#: src/pages/home.jsx:184
#: src/pages/notifications.jsx:112
#: src/pages/notifications.jsx:524
msgid "Notifications"
msgstr "Benachrichtigungen"

#: src/components/nav-menu.jsx:217
msgid "New"
msgstr "Neu"

#: src/components/nav-menu.jsx:228
msgid "Profile"
msgstr "Profil"

#: src/components/nav-menu.jsx:241
#: src/components/nav-menu.jsx:268
#: src/components/shortcuts-settings.jsx:50
#: src/components/shortcuts-settings.jsx:158
#: src/pages/list.jsx:126
#: src/pages/lists.jsx:16
#: src/pages/lists.jsx:50
msgid "Lists"
msgstr "Listen"

#: src/components/nav-menu.jsx:249
#: src/components/shortcuts.jsx:215
#: src/pages/list.jsx:133
msgid "All Lists"
msgstr "Alle Listen"

#: src/components/nav-menu.jsx:276
#: src/components/shortcuts-settings.jsx:54
#: src/components/shortcuts-settings.jsx:195
#: src/pages/bookmarks.jsx:11
#: src/pages/bookmarks.jsx:23
msgid "Bookmarks"
msgstr "Lesezeichen"

#: src/components/nav-menu.jsx:296
#: src/components/shortcuts-settings.jsx:55
#: src/components/shortcuts-settings.jsx:201
#: src/pages/catchup.jsx:1446
#: src/pages/catchup.jsx:2062
#: src/pages/favourites.jsx:11
#: src/pages/favourites.jsx:23
#: src/pages/settings.jsx:1106
msgid "Likes"
msgstr "Gefällt mir"

#: src/components/nav-menu.jsx:302
#: src/pages/followed-hashtags.jsx:14
#: src/pages/followed-hashtags.jsx:44
msgid "Followed Hashtags"
msgstr "Gefolgte Hashtags"

#: src/components/nav-menu.jsx:310
#: src/pages/account-statuses.jsx:331
#: src/pages/filters.jsx:54
#: src/pages/filters.jsx:93
#: src/pages/hashtag.jsx:339
msgid "Filters"
msgstr "Filter"

#: src/components/nav-menu.jsx:318
msgid "Muted users"
msgstr "Stumm geschaltete Nutzer"

#: src/components/nav-menu.jsx:326
msgid "Muted users…"
msgstr "Stumm geschaltete Nutzer…"

#: src/components/nav-menu.jsx:333
msgid "Blocked users"
msgstr "Blockierte Nutzer"

#: src/components/nav-menu.jsx:341
msgid "Blocked users…"
msgstr "Blockierte Nutzer…"

#: src/components/nav-menu.jsx:353
msgid "Accounts…"
msgstr "Konten…"

#: src/components/nav-menu.jsx:363
#: src/pages/login.jsx:189
#: src/pages/status.jsx:835
#: src/pages/welcome.jsx:64
msgid "Log in"
msgstr "Einloggen"

#: src/components/nav-menu.jsx:380
#: src/components/shortcuts-settings.jsx:57
#: src/components/shortcuts-settings.jsx:172
#: src/pages/trending.jsx:441
msgid "Trending"
msgstr "Angesagt"

#: src/components/nav-menu.jsx:392
#: src/components/shortcuts-settings.jsx:165
msgid "Federated"
msgstr "Föderiert"

#: src/components/nav-menu.jsx:415
msgid "Shortcuts / Columns…"
msgstr "Verknüpfungen / Spalten…"

#: src/components/nav-menu.jsx:425
#: src/components/nav-menu.jsx:439
msgid "Settings…"
msgstr "Einstellungen…"

#: src/components/notification-service.jsx:160
msgid "Notification"
msgstr "Benachrichtigung"

#: src/components/notification-service.jsx:166
msgid "This notification is from your other account."
msgstr "Diese Benachrichtigung stammt von Ihrem anderen Konto."

#: src/components/notification-service.jsx:195
msgid "View all notifications"
msgstr "Alle Benachrichtigungen anzeigen"

#: src/components/notification.jsx:70
msgid "{account} reacted to your post with {emojiObject}"
msgstr "{account} hat auf Ihren Beitrag mit {emojiObject} reagiert"

#: src/components/notification.jsx:77
msgid "{account} published a post."
msgstr "{account} hat einen Post veröffentlicht."

#: src/components/notification.jsx:85
msgid "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} boosted your reply.} other {{account} boosted your post.}}} other {{account} boosted {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> boosted your reply.} other {<2><3>{1}</3> people</2> boosted your post.}}}}"
msgstr "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} hat deine Antwort geteilt.} other {{account} hat deinen Beitrag geteilt.}}} other {{account} hat {postsCount} Beiträge von dir geteilt.}}} other {{postType, select, reply {<0><1>{0}</1> Leute</0> haben deine Antwort geteilt.} other {<2><3>{1}</3> Leute</2> haben deinen Beitrag geteilt.}}}}"

#: src/components/notification.jsx:128
msgid "{count, plural, =1 {{account} followed you.} other {<0><1>{0}</1> people</0> followed you.}}"
msgstr "{count, plural, =1 {{account} folgt dir jetzt.} other {<0><1>{0}</1> Leute</0> folgen dir jetzt.}}"

#: src/components/notification.jsx:142
msgid "{account} requested to follow you."
msgstr "{account} hat darum gebeten, Ihnen zu folgen."

#: src/components/notification.jsx:151
msgid "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} liked your reply.} other {{account} liked your post.}}} other {{account} liked {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> liked your reply.} other {<2><3>{1}</3> people</2> liked your post.}}}}"
msgstr "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} hat deine Antwort favorisiert.} other {{account} hat deinen Beitrag favorisiert.}}} other {{account} hat {postsCount} Beiträge von dir favorisiert.}}} other {{postType, select, reply {<0><1>{0}</1> Leute</0> haben deine Antwort favorisiert.} other {<2><3>{1}</3> Leute</2> haben deinen Beitrag favorisiert.}}}}"

#: src/components/notification.jsx:193
msgid "A poll you have voted in or created has ended."
msgstr "Eine Umfrage hat geendet, an der du teilgenommen oder die du erstellt hast."

#: src/components/notification.jsx:194
msgid "A poll you have created has ended."
msgstr "Eine von Ihnen erstellte Umfrage wurde beendet."

#: src/components/notification.jsx:195
msgid "A poll you have voted in has ended."
msgstr "Eine Umfrage in der Sie teilgenommen haben wurde beendet."

#: src/components/notification.jsx:196
msgid "A post you interacted with has been edited."
msgstr "Ein Post, mit dem Sie interagiert haben, wurde bearbeitet."

#: src/components/notification.jsx:204
msgid "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} boosted & liked your reply.} other {{account} boosted & liked your post.}}} other {{account} boosted & liked {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> boosted & liked your reply.} other {<2><3>{1}</3> people</2> boosted & liked your post.}}}}"
msgstr "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} hat deine Antwort geteilt & favorisiert.} other {{account} hat deinen Beitrag geteilt & favorisiert.}}} other {{account} hat {postsCount} deiner Beiträge geteilt & favorisiert.}}} other {{postType, select, reply {<0><1>{0}</1> Leute</0> haben deine Antwort geteilt & favorisiert.} other {<2><3>{1}</3> Leute</2> haben deinen Beitrag geteilt & favorisiert.}}}}"

#: src/components/notification.jsx:246
msgid "{account} signed up."
msgstr "{account} registriert."

#: src/components/notification.jsx:248
msgid "{account} reported {targetAccount}"
msgstr "{account} hat {targetAccount} gemeldet"

#: src/components/notification.jsx:253
msgid "Lost connections with <0>{name}</0>."
msgstr "Verbindungen mit <0>{name}</0> verloren."

#: src/components/notification.jsx:259
msgid "Moderation warning"
msgstr "Moderationswarnung"

#: src/components/notification.jsx:269
msgid "An admin from <0>{from}</0> has suspended <1>{targetName}</1>, which means you can no longer receive updates from them or interact with them."
msgstr "Ein Admin von <0>{from}</0> hat <1>{targetName}</1> gesperrt, weshalb du von diesem Profil nichts mehr wirst sehen und mit ihm nicht mehr wirst interagieren können."

#: src/components/notification.jsx:275
msgid "An admin from <0>{from}</0> has blocked <1>{targetName}</1>. Affected followers: {followersCount}, followings: {followingCount}."
msgstr "Ein Admin von <0>{from}</0> hat <1>{targetName}</1> gesperrt. Betroffene Follower: {followersCount}; Profile, denen er/sie folgt: {followingCount}."

#: src/components/notification.jsx:281
msgid "You have blocked <0>{targetName}</0>. Removed followers: {followersCount}, followings: {followingCount}."
msgstr ""

#: src/components/notification.jsx:289
msgid "Your account has received a moderation warning."
msgstr "Ihr Konto hat eine Moderationswarnung erhalten."

#: src/components/notification.jsx:290
msgid "Your account has been disabled."
msgstr "Ihr Konto wurde deaktiviert."

#: src/components/notification.jsx:291
msgid "Some of your posts have been marked as sensitive."
msgstr "Einige Ihrer Beiträge wurden als sensibel markiert."

#: src/components/notification.jsx:292
msgid "Some of your posts have been deleted."
msgstr "Einige Ihrer Beiträge wurden gelöscht."

#: src/components/notification.jsx:293
msgid "Your posts will be marked as sensitive from now on."
msgstr "Ihre Beiträge werden von nun an als sensibel markiert."

#: src/components/notification.jsx:294
msgid "Your account has been limited."
msgstr "Ihr Konto wurde eingeschränkt."

#: src/components/notification.jsx:295
msgid "Your account has been suspended."
msgstr "Ihr Konto wurde gesperrt."

#: src/components/notification.jsx:369
msgid "[Unknown notification type: {type}]"
msgstr "[Unbekannter Benachrichtigungstyp: {type}]"

#: src/components/notification.jsx:434
#: src/components/status.jsx:1020
#: src/components/status.jsx:1030
msgid "Boosted/Liked by…"
msgstr "Geteilt/favorisiert von …"

#: src/components/notification.jsx:435
msgid "Liked by…"
msgstr "Favorisiert von …"

#: src/components/notification.jsx:436
msgid "Boosted by…"
msgstr "Geboostet von…"

#: src/components/notification.jsx:437
msgid "Followed by…"
msgstr "Gefolgt von…"

#: src/components/notification.jsx:508
#: src/components/notification.jsx:524
msgid "Learn more <0/>"
msgstr "Erfahre mehr <0/>"

#: src/components/notification.jsx:756
#: src/components/status.jsx:251
msgid "Read more →"
msgstr "Mehr lesen →"

#: src/components/poll.jsx:110
msgid "Voted"
msgstr "Abgestimmt"

#: src/components/poll.jsx:116
msgid "{optionVotesCount, plural, one {# vote} other {# votes}}"
msgstr ""

#: src/components/poll.jsx:136
#: src/components/poll.jsx:219
#: src/components/poll.jsx:223
msgid "Hide results"
msgstr "Ergebnisse ausblenden"

#: src/components/poll.jsx:185
msgid "Vote"
msgstr "Abstimmen"

#: src/components/poll.jsx:205
#: src/components/poll.jsx:207
#: src/pages/status.jsx:1201
#: src/pages/status.jsx:1224
msgid "Refresh"
msgstr "Aktualisieren"

#: src/components/poll.jsx:219
#: src/components/poll.jsx:223
msgid "Show results"
msgstr "Ergebnisse anzeigen"

#: src/components/poll.jsx:228
msgid "{votesCount, plural, one {<0>{0}</0> vote} other {<1>{1}</1> votes}}"
msgstr "{votesCount, plural, one {<0>{0}</0> Stimme} other {<1>{1}</1> Stimmen}}"

#: src/components/poll.jsx:245
msgid "{votersCount, plural, one {<0>{0}</0> voter} other {<1>{1}</1> voters}}"
msgstr "{votersCount, plural, one {<0>{0}</0> Abstimmender} other {<1>{1}</1> Abstimmende}}"

#: src/components/poll.jsx:265
msgid "Ended <0/>"
msgstr "Beendet <0/>"

#: src/components/poll.jsx:269
msgid "Ended"
msgstr "Beendet"

#: src/components/poll.jsx:272
msgid "Ending <0/>"
msgstr ""

#: src/components/poll.jsx:276
msgid "Ending"
msgstr "Endet"

#. Relative time in seconds, as short as possible
#: src/components/relative-time.jsx:57
msgid "{0}s"
msgstr "{0}s"

#. Relative time in minutes, as short as possible
#: src/components/relative-time.jsx:62
msgid "{0}m"
msgstr "{0}m"

#. Relative time in hours, as short as possible
#: src/components/relative-time.jsx:67
msgid "{0}h"
msgstr "{0}h"

#: src/components/report-modal.jsx:29
msgid "Spam"
msgstr "Spam"

#: src/components/report-modal.jsx:30
msgid "Malicious links, fake engagement, or repetitive replies"
msgstr "Bösartige Links, gefälschtes Engagement oder wiederholte Antworten"

#: src/components/report-modal.jsx:33
msgid "Illegal"
msgstr "Illegal"

#: src/components/report-modal.jsx:34
msgid "Violates the law of your or the server's country"
msgstr "Verstößt gegen das Gesetz Ihres oder des Serverlandes"

#: src/components/report-modal.jsx:37
msgid "Server rule violation"
msgstr "Verstoß gegen Server-Regeln"

#: src/components/report-modal.jsx:38
msgid "Breaks specific server rules"
msgstr "Verstößt gegen bestimmte Server-Regel"

#: src/components/report-modal.jsx:39
msgid "Violation"
msgstr "Verstoß"

#: src/components/report-modal.jsx:42
msgid "Other"
msgstr "Andere"

#: src/components/report-modal.jsx:43
msgid "Issue doesn't fit other categories"
msgstr "Problem passt nicht zu anderen Kategorien"

#: src/components/report-modal.jsx:68
msgid "Report Post"
msgstr "Post melden"

#: src/components/report-modal.jsx:68
msgid "Report @{username}"
msgstr "Melde @{username}"

#: src/components/report-modal.jsx:104
msgid "Pending review"
msgstr "Ausstehende Prüfung"

#: src/components/report-modal.jsx:146
msgid "Post reported"
msgstr "Post gemeldet"

#: src/components/report-modal.jsx:146
msgid "Profile reported"
msgstr "Profil gemeldet"

#: src/components/report-modal.jsx:154
msgid "Unable to report post"
msgstr "Post konnte nicht gemeldet werden"

#: src/components/report-modal.jsx:155
msgid "Unable to report profile"
msgstr "Profil konnte nicht gemeldet werden"

#: src/components/report-modal.jsx:163
msgid "What's the issue with this post?"
msgstr "Was ist das Problem mit diesem Post?"

#: src/components/report-modal.jsx:164
msgid "What's the issue with this profile?"
msgstr "Was ist das Problem mit diesem Profil?"

#: src/components/report-modal.jsx:233
msgid "Additional info"
msgstr "Zusätzliche Infos"

#: src/components/report-modal.jsx:256
msgid "Forward to <0>{domain}</0>"
msgstr "An <0>{domain}</0> weiterleiten"

#: src/components/report-modal.jsx:266
msgid "Send Report"
msgstr "Meldung senden"

#: src/components/report-modal.jsx:275
msgid "Muted {username}"
msgstr "@{username} Stumm geschaltet"

#: src/components/report-modal.jsx:278
msgid "Unable to mute {username}"
msgstr "Konnte {username} nicht Stumm schalten"

#: src/components/report-modal.jsx:283
msgid "Send Report <0>+ Mute profile</0>"
msgstr "Meldung absenden <0>+ Profil stumm schalten</0>"

#: src/components/report-modal.jsx:294
msgid "Blocked {username}"
msgstr "{username} blockiert"

#: src/components/report-modal.jsx:297
msgid "Unable to block {username}"
msgstr "Konnte {username} nicht blockieren"

#: src/components/report-modal.jsx:302
msgid "Send Report <0>+ Block profile</0>"
msgstr "Meldung absenden <0>+ Profil blockieren</0>"

#: src/components/search-form.jsx:202
msgid "{query} <0>‒ accounts, hashtags & posts</0>"
msgstr "{query} <0>– Konten, Hashtags & Beiträge</0>"

#: src/components/search-form.jsx:215
msgid "Posts with <0>{query}</0>"
msgstr "Beiträge mit <0>{query}</0>"

#: src/components/search-form.jsx:227
msgid "Posts tagged with <0>#{0}</0>"
msgstr "Beiträge mit dem Hashtag <0>#{0}</0>"

#: src/components/search-form.jsx:241
msgid "Look up <0>{query}</0>"
msgstr "<0>{query}</0> nachschlagen"

#: src/components/search-form.jsx:252
msgid "Accounts with <0>{query}</0>"
msgstr "Konten mit <0>{query}</0>"

#: src/components/shortcuts-settings.jsx:48
msgid "Home / Following"
msgstr "Startseite / Folgen"

#: src/components/shortcuts-settings.jsx:51
msgid "Public (Local / Federated)"
msgstr "Öffentlich (Lokal / Föderiert)"

#: src/components/shortcuts-settings.jsx:53
msgid "Account"
msgstr "Konto"

#: src/components/shortcuts-settings.jsx:56
msgid "Hashtag"
msgstr "Hashtag"

#: src/components/shortcuts-settings.jsx:63
msgid "List ID"
msgstr "Listen-ID"

#: src/components/shortcuts-settings.jsx:70
msgid "Local only"
msgstr "Nur Lokal"

#: src/components/shortcuts-settings.jsx:75
#: src/components/shortcuts-settings.jsx:84
#: src/components/shortcuts-settings.jsx:122
#: src/pages/login.jsx:193
msgid "Instance"
msgstr "Instanz"

#: src/components/shortcuts-settings.jsx:78
#: src/components/shortcuts-settings.jsx:87
#: src/components/shortcuts-settings.jsx:125
msgid "Optional, e.g. mastodon.social"
msgstr "Optional, z.B. mastodon.social"

#: src/components/shortcuts-settings.jsx:93
msgid "Search term"
msgstr "Suchbegriff"

#: src/components/shortcuts-settings.jsx:96
msgid "Optional, unless for multi-column mode"
msgstr "Optional, außer für Mehrspalten-Modus"

#: src/components/shortcuts-settings.jsx:113
msgid "e.g. PixelArt (Max 5, space-separated)"
msgstr "z.B. PixelArt (max. 5, durch Leerzeichen getrennt)"

#: src/components/shortcuts-settings.jsx:117
#: src/pages/hashtag.jsx:355
msgid "Media only"
msgstr "Nur Medien"

#: src/components/shortcuts-settings.jsx:235
#: src/components/shortcuts.jsx:192
msgid "Shortcuts"
msgstr "Tastenkürzel"

#: src/components/shortcuts-settings.jsx:243
msgid "beta"
msgstr "Beta"

#: src/components/shortcuts-settings.jsx:249
msgid "Specify a list of shortcuts that'll appear as:"
msgstr "Gib eine Liste an mit Verknüpfungen, die erscheinen werden als:"

#: src/components/shortcuts-settings.jsx:255
msgid "Floating button"
msgstr "Schwebender Button"

#: src/components/shortcuts-settings.jsx:260
msgid "Tab/Menu bar"
msgstr "Tab/Menüleiste"

#: src/components/shortcuts-settings.jsx:265
msgid "Multi-column"
msgstr "Mehrere Spalten"

#: src/components/shortcuts-settings.jsx:332
msgid "Not available in current view mode"
msgstr "Im aktuellen Ansichtsmodus nicht verfügbar"

#: src/components/shortcuts-settings.jsx:351
msgid "Move up"
msgstr "Nach oben"

#: src/components/shortcuts-settings.jsx:367
msgid "Move down"
msgstr "Nach unten"

#: src/components/shortcuts-settings.jsx:379
#: src/components/status.jsx:1298
#: src/pages/list.jsx:170
msgid "Edit"
msgstr "Bearbeiten"

#: src/components/shortcuts-settings.jsx:400
msgid "Add more than one shortcut/column to make this work."
msgstr "Fügen Sie mehr als eine Verknüpfung/Spalte hinzu, damit dies funktioniert."

#: src/components/shortcuts-settings.jsx:411
msgid "No columns yet. Tap on the Add column button."
msgstr "Noch keine Spalten. Tippen Sie auf die Hinzufügen Schaltfläche."

#: src/components/shortcuts-settings.jsx:412
msgid "No shortcuts yet. Tap on the Add shortcut button."
msgstr "Noch keine Verknüpfungen. Tippen Sie auf die Hinzufügen Schaltfläche."

#: src/components/shortcuts-settings.jsx:415
msgid "Not sure what to add?<0/>Try adding <1>Home / Following and Notifications</1> first."
msgstr "Unentschlossen, was du hinzufügen sollst?<0/>Probier’ es zuerst mit <1>Start / Folgend und Benachrichtigungen</1>."

#: src/components/shortcuts-settings.jsx:443
msgid "Max {SHORTCUTS_LIMIT} columns"
msgstr "Höchstens {SHORTCUTS_LIMIT} Spalten"

#: src/components/shortcuts-settings.jsx:444
msgid "Max {SHORTCUTS_LIMIT} shortcuts"
msgstr "Höchstens {SHORTCUTS_LIMIT} Verknüpfungen"

#: src/components/shortcuts-settings.jsx:458
msgid "Import/export"
msgstr "Import/Export"

#: src/components/shortcuts-settings.jsx:468
msgid "Add column…"
msgstr "Spalte hinzufügen…"

#: src/components/shortcuts-settings.jsx:469
msgid "Add shortcut…"
msgstr "Verknüpfung hinzufügen…"

#: src/components/shortcuts-settings.jsx:516
msgid "Specific list is optional. For multi-column mode, list is required, else the column will not be shown."
msgstr "Bestimmte Liste ist optional. Im Mehrspalten-Modus ist eine Liste erforderlich, sonst wird die Spalte nicht angezeigt."

#: src/components/shortcuts-settings.jsx:517
msgid "For multi-column mode, search term is required, else the column will not be shown."
msgstr "Im Mehrspalten-Modus ist ein Suchbegriff erforderlich, sonst wird die Spalte nicht angezeigt."

#: src/components/shortcuts-settings.jsx:518
msgid "Multiple hashtags are supported. Space-separated."
msgstr "Es werden mehrere Hashtags gleichzeitig unterstützt. Separiert mit Leerzeichen."

#: src/components/shortcuts-settings.jsx:587
msgid "Edit shortcut"
msgstr "Verknüpfung bearbeiten"

#: src/components/shortcuts-settings.jsx:587
msgid "Add shortcut"
msgstr "Verknüpfung hinzufügen"

#: src/components/shortcuts-settings.jsx:623
msgid "Timeline"
msgstr "Timeline"

#: src/components/shortcuts-settings.jsx:649
msgid "List"
msgstr "Liste"

#: src/components/shortcuts-settings.jsx:788
msgid "Import/Export <0>Shortcuts</0>"
msgstr "<0>Verknüpfungen</0> importierten/exportieren"

#: src/components/shortcuts-settings.jsx:798
msgid "Import"
msgstr "Importieren"

#: src/components/shortcuts-settings.jsx:806
msgid "Paste shortcuts here"
msgstr "Verknüpfung hier einfügen"

#: src/components/shortcuts-settings.jsx:822
msgid "Downloading saved shortcuts from instance server…"
msgstr "Lade gespeicherte Verknüpfungen von Instanz-Server herunter…"

#: src/components/shortcuts-settings.jsx:851
msgid "Unable to download shortcuts"
msgstr "Verknüpfungen konnten nicht heruntergeladen werden"

#: src/components/shortcuts-settings.jsx:854
msgid "Download shortcuts from instance server"
msgstr "Verknüpfungen vom Instanz-Server herunterladen"

#: src/components/shortcuts-settings.jsx:912
msgid "* Exists in current shortcuts"
msgstr "* Existiert in den aktuellen Verknüpfungen"

#: src/components/shortcuts-settings.jsx:917
msgid "List may not work if it's from a different account."
msgstr "Liste funktioniert möglicherweise nicht, wenn sie von einem anderen Konto stammt."

#: src/components/shortcuts-settings.jsx:927
msgid "Invalid settings format"
msgstr "Ungültiges Einstellungsformat"

#: src/components/shortcuts-settings.jsx:935
msgid "Append to current shortcuts?"
msgstr "An aktuelle Verknüpfungen anhängen?"

#: src/components/shortcuts-settings.jsx:938
msgid "Only shortcuts that don’t exist in current shortcuts will be appended."
msgstr "Es werden nur Verknüpfungen angehängt, die in den aktuellen Verknüpfungen nicht vorhanden sind."

#: src/components/shortcuts-settings.jsx:960
msgid "No new shortcuts to import"
msgstr "Keine neuen Verknüpfungen zum Importieren"

#: src/components/shortcuts-settings.jsx:975
msgid "Shortcuts imported. Exceeded max {SHORTCUTS_LIMIT}, so the rest are not imported."
msgstr "Limit {SHORTCUTS_LIMIT} wurde überschritten, es wurde nur ein Teil der Verknüpfungen importiert."

#: src/components/shortcuts-settings.jsx:976
#: src/components/shortcuts-settings.jsx:1000
msgid "Shortcuts imported"
msgstr "Verknüpfungen importiert"

#: src/components/shortcuts-settings.jsx:986
msgid "Import & append…"
msgstr "Importieren & Anhängen…"

#: src/components/shortcuts-settings.jsx:994
msgid "Override current shortcuts?"
msgstr "Aktuelle Verknüpfungen überschreiben?"

#: src/components/shortcuts-settings.jsx:995
msgid "Import shortcuts?"
msgstr "Verknüpfungen importieren?"

#: src/components/shortcuts-settings.jsx:1009
msgid "or override…"
msgstr "oder überschreiben…"

#: src/components/shortcuts-settings.jsx:1009
msgid "Import…"
msgstr "Importieren…"

#: src/components/shortcuts-settings.jsx:1018
msgid "Export"
msgstr "Exportieren"

#: src/components/shortcuts-settings.jsx:1033
msgid "Shortcuts copied"
msgstr "Verknüpfungen kopiert"

#: src/components/shortcuts-settings.jsx:1036
msgid "Unable to copy shortcuts"
msgstr "Konnte Verknüpfungen nicht kopieren"

#: src/components/shortcuts-settings.jsx:1050
msgid "Shortcut settings copied"
msgstr "Verknüpfungseinstellungen kopiert"

#: src/components/shortcuts-settings.jsx:1053
msgid "Unable to copy shortcut settings"
msgstr "Konnte Verknüpfungseinstellungen nicht kopieren"

#: src/components/shortcuts-settings.jsx:1083
msgid "Share"
msgstr "Teilen"

#: src/components/shortcuts-settings.jsx:1122
msgid "Saving shortcuts to instance server…"
msgstr "Verknüpfungen werden auf Instanz-Server gespeichert …"

#: src/components/shortcuts-settings.jsx:1129
msgid "Shortcuts saved"
msgstr "Verknüpfungen gespeichert"

#: src/components/shortcuts-settings.jsx:1134
msgid "Unable to save shortcuts"
msgstr "Verknüpfungen konnten nicht gespeichert werden"

#: src/components/shortcuts-settings.jsx:1137
msgid "Sync to instance server"
msgstr "Mit Instanzserver synchronisieren"

#: src/components/shortcuts-settings.jsx:1145
msgid "{0, plural, one {# character} other {# characters}}"
msgstr "{0, plural, one {# Zeichen} other {# Zeichen}}"

#: src/components/shortcuts-settings.jsx:1157
msgid "Raw Shortcuts JSON"
msgstr "Rohes Verknüpfungs-JSON"

#: src/components/shortcuts-settings.jsx:1170
msgid "Import/export settings from/to instance server (Very experimental)"
msgstr "Einstellungen vom/zum Instanzserver importieren/exportieren (hochgradig experimentell)"

#: src/components/status.jsx:522
msgid "<0/> <1>boosted</1>"
msgstr "<0/> <1>geteilt</1>"

#: src/components/status.jsx:621
msgid "Sorry, your current logged-in instance can't interact with this post from another instance."
msgstr "Entschuldigung, deine aktuell verwendete Instanz kann nicht mit diesem von einer anderen Instanz stammenden Beitrag interagieren."

#: src/components/status.jsx:774
msgid "Unliked @{0}'s post"
msgstr "Beitrag von @{0} entfavorisiert"

#: src/components/status.jsx:775
msgid "Liked @{0}'s post"
msgstr "Beitrag von @{0} favorisiert"

#: src/components/status.jsx:814
msgid "Unbookmarked @{0}'s post"
msgstr "Lesezeichen entfernt für Beitrag von @{0}"

#: src/components/status.jsx:815
msgid "Bookmarked @{0}'s post"
msgstr "Lesezeichen erstellt für Beitrag von @{0}"

#: src/components/status.jsx:921
#: src/components/status.jsx:983
#: src/components/status.jsx:2396
#: src/components/status.jsx:2428
msgid "Unboost"
msgstr "Nicht mehr teilen"

#: src/components/status.jsx:937
#: src/components/status.jsx:2411
msgid "Quote"
msgstr "Zitieren"

#: src/components/status.jsx:945
#: src/components/status.jsx:2420
msgid "Some media have no descriptions."
msgstr "Einige Medien haben keine Beschreibungen."

#: src/components/status.jsx:952
msgid "Old post (<0>{0}</0>)"
msgstr "Alter Beitrag (<0>{0}</0>)"

#: src/components/status.jsx:971
#: src/components/status.jsx:1426
msgid "Unboosted @{0}'s post"
msgstr "Teilen des Betrags von @{0} rückgängig gemacht"

#: src/components/status.jsx:972
#: src/components/status.jsx:1427
msgid "Boosted @{0}'s post"
msgstr "Beitrag von @{0} geteilt"

#: src/components/status.jsx:984
msgid "Boost…"
msgstr "Boost…"

#: src/components/status.jsx:996
#: src/components/status.jsx:1711
#: src/components/status.jsx:2441
msgid "Unlike"
msgstr "Entfavorisieren"

#: src/components/status.jsx:997
#: src/components/status.jsx:1711
#: src/components/status.jsx:1712
#: src/components/status.jsx:2441
#: src/components/status.jsx:2442
msgid "Like"
msgstr "Favorisieren"

#: src/components/status.jsx:1006
#: src/components/status.jsx:2453
msgid "Unbookmark"
msgstr "Lesezeichen entfernen"

#: src/components/status.jsx:1114
msgid "View post by <0>@{0}</0>"
msgstr ""

#: src/components/status.jsx:1135
msgid "Show Edit History"
msgstr "Bearbeitungsverlauf anzeigen"

#: src/components/status.jsx:1138
msgid "Edited: {editedDateText}"
msgstr "Bearbeitet: {editedDateText}"

#: src/components/status.jsx:1205
#: src/components/status.jsx:3220
msgid "Embed post"
msgstr "Beitrag einbetten"

#: src/components/status.jsx:1219
msgid "Conversation unmuted"
msgstr "Unterhaltung entstummt"

#: src/components/status.jsx:1219
msgid "Conversation muted"
msgstr "Unterhaltung stumm geschaltet"

#: src/components/status.jsx:1225
msgid "Unable to unmute conversation"
msgstr "Unterhaltung kann nicht entstummt werden"

#: src/components/status.jsx:1226
msgid "Unable to mute conversation"
msgstr "Unterhaltung kann nicht stumm geschaltet werden"

#: src/components/status.jsx:1235
msgid "Unmute conversation"
msgstr "Unterhaltung entstummen"

#: src/components/status.jsx:1242
msgid "Mute conversation"
msgstr "Unterhaltung stumm schalten"

#: src/components/status.jsx:1258
msgid "Post unpinned from profile"
msgstr "Beitrag vom Profil gelöst"

#: src/components/status.jsx:1259
msgid "Post pinned to profile"
msgstr "Beitrag ans Profil angeheftet"

#: src/components/status.jsx:1264
msgid "Unable to unpin post"
msgstr "Beitrag kann nicht gelöst werden"

#: src/components/status.jsx:1264
msgid "Unable to pin post"
msgstr "Beitrag kann nicht angeheftet werden"

#: src/components/status.jsx:1273
msgid "Unpin from profile"
msgstr "Vom Profil lösen"

#: src/components/status.jsx:1280
msgid "Pin to profile"
msgstr "Ans Profil anheften"

#: src/components/status.jsx:1309
msgid "Delete this post?"
msgstr "Diesen Post löschen?"

#: src/components/status.jsx:1325
msgid "Post deleted"
msgstr "Post gelöscht"

#: src/components/status.jsx:1328
msgid "Unable to delete post"
msgstr "Post konnte nicht gelöscht werden"

#: src/components/status.jsx:1356
msgid "Report post…"
msgstr "Post melden…"

#: src/components/status.jsx:1712
#: src/components/status.jsx:1748
#: src/components/status.jsx:2442
msgid "Liked"
msgstr "Favorisiert"

#: src/components/status.jsx:1745
#: src/components/status.jsx:2429
msgid "Boosted"
msgstr "Geboostet"

#: src/components/status.jsx:1755
#: src/components/status.jsx:2454
msgid "Bookmarked"
msgstr "Lesezeichen hinzugefügt"

#: src/components/status.jsx:1759
msgid "Pinned"
msgstr "Angeheftet"

#: src/components/status.jsx:1804
#: src/components/status.jsx:2260
msgid "Deleted"
msgstr "Gelöscht"

#: src/components/status.jsx:1845
msgid "{repliesCount, plural, one {# reply} other {# replies}}"
msgstr "{repliesCount, plural, one {# Antwort} other {# Antworten}}"

#: src/components/status.jsx:1934
msgid "Thread{0}"
msgstr "Thread{0}"

#: src/components/status.jsx:2010
#: src/components/status.jsx:2072
#: src/components/status.jsx:2157
msgid "Show less"
msgstr "Weniger anzeigen"

#: src/components/status.jsx:2010
#: src/components/status.jsx:2072
msgid "Show content"
msgstr "Inhalt anzeigen"

#: src/components/status.jsx:2157
msgid "Show media"
msgstr "Medien anzeigen"

#: src/components/status.jsx:2294
msgid "Edited"
msgstr "Bearbeitet"

#: src/components/status.jsx:2371
msgid "Comments"
msgstr "Kommentare"

#. More from [Author]
#: src/components/status.jsx:2680
msgid "More from <0/>"
msgstr ""

#: src/components/status.jsx:2981
msgid "Edit History"
msgstr "Bearbeitungsverlauf"

#: src/components/status.jsx:2985
msgid "Failed to load history"
msgstr "Fehler beim laden des Verlaufs"

#: src/components/status.jsx:2990
msgid "Loading…"
msgstr "Laden…"

#: src/components/status.jsx:3225
msgid "HTML Code"
msgstr "HTML Code"

#: src/components/status.jsx:3242
msgid "HTML code copied"
msgstr "HTML Code kopiert"

#: src/components/status.jsx:3245
msgid "Unable to copy HTML code"
msgstr "HTML-Code konnte nicht kopiert werden"

#: src/components/status.jsx:3257
msgid "Media attachments:"
msgstr "Medienanhänge:"

#: src/components/status.jsx:3279
msgid "Account Emojis:"
msgstr "Account-Emojis:"

#: src/components/status.jsx:3310
#: src/components/status.jsx:3355
msgid "static URL"
msgstr "Statische URL"

#: src/components/status.jsx:3324
msgid "Emojis:"
msgstr "Emojis:"

#: src/components/status.jsx:3369
msgid "Notes:"
msgstr "Notizen:"

#: src/components/status.jsx:3373
msgid "This is static, unstyled and scriptless. You may need to apply your own styles and edit as needed."
msgstr "Dies ist statisch, ungestylt und ohne Skript. Du kannst nach Belieben deine eigenen Styles anwenden und bearbeiten."

#: src/components/status.jsx:3379
msgid "Polls are not interactive, becomes a list with vote counts."
msgstr "Umfragen sind nicht interaktiv, es wird eine Liste mit Stimmanzahlen."

#: src/components/status.jsx:3384
msgid "Media attachments can be images, videos, audios or any file types."
msgstr "Medienanhänge können Bilder, Videos, Audiodateien oder andere Dateitypen sein."

#: src/components/status.jsx:3390
msgid "Post could be edited or deleted later."
msgstr "Beitrag konnte später geändert oder gelöscht werden."

#: src/components/status.jsx:3396
msgid "Preview"
msgstr "Vorschau"

#: src/components/status.jsx:3405
msgid "Note: This preview is lightly styled."
msgstr "Notiz: Diese Vorschau ist leicht formiert."

#. [Name] [Visibility icon] boosted
#: src/components/status.jsx:3647
msgid "<0/> <1/> boosted"
msgstr "<0/> <1/> geteilt"

#: src/components/timeline.jsx:453
#: src/pages/settings.jsx:1130
msgid "New posts"
msgstr "Neue Posts"

#: src/components/timeline.jsx:554
#: src/pages/home.jsx:213
#: src/pages/notifications.jsx:824
#: src/pages/status.jsx:988
#: src/pages/status.jsx:1361
msgid "Try again"
msgstr "Erneut versuchen"

#: src/components/timeline.jsx:588
msgid "{0, plural, one {# Boost} other {# Boosts}}"
msgstr ""

#: src/components/timeline.jsx:593
msgid "Pinned posts"
msgstr ""

#: src/components/timeline.jsx:946
#: src/components/timeline.jsx:953
#: src/pages/catchup.jsx:1893
msgid "Thread"
msgstr "Thread"

#: src/components/timeline.jsx:968
msgid "<0>Filtered</0>: <1>{0}</1>"
msgstr "<0>Herausgefiltert</0>: <1>{0}</1>"

#: src/components/translation-block.jsx:152
msgid "Auto-translated from {sourceLangText}"
msgstr "Automatisch von {sourceLangText} übersetzt"

#: src/components/translation-block.jsx:190
msgid "Translating…"
msgstr "Übersetze…"

#: src/components/translation-block.jsx:193
msgid "Translate from {sourceLangText} (auto-detected)"
msgstr "Von {sourceLangText} übersetzen (automatisch erkannt)"

#: src/components/translation-block.jsx:194
msgid "Translate from {sourceLangText}"
msgstr "Von {sourceLangText} übersetzen"

#: src/components/translation-block.jsx:222
msgid "Auto ({0})"
msgstr "Auto ({0})"

#: src/components/translation-block.jsx:235
msgid "Failed to translate"
msgstr "Übersetzung fehlgeschlagen"

#: src/compose.jsx:32
msgid "Editing source status"
msgstr "Quell-Status bearbeiten"

#: src/compose.jsx:34
msgid "Replying to @{0}"
msgstr "Antworten auf @{0}"

#: src/compose.jsx:62
msgid "You may close this page now."
msgstr "Sie können diese Seite jetzt schließen."

#: src/compose.jsx:70
msgid "Close window"
msgstr "Fenster schließen"

#: src/compose.jsx:86
msgid "Login required."
msgstr ""

#: src/compose.jsx:90
#: src/pages/http-route.jsx:91
#: src/pages/login.jsx:270
msgid "Go home"
msgstr "Zur Startseite gehen"

#: src/pages/account-statuses.jsx:233
msgid "Account posts"
msgstr "Account-Posts"

#: src/pages/account-statuses.jsx:240
msgid "{accountDisplay} (+ Replies)"
msgstr "{accountDisplay} (+ Antworten)"

#: src/pages/account-statuses.jsx:242
msgid "{accountDisplay} (- Boosts)"
msgstr "{accountDisplay} (- Boosts)"

#: src/pages/account-statuses.jsx:244
msgid "{accountDisplay} (#{tagged})"
msgstr "{accountDisplay} (#{tagged})"

#: src/pages/account-statuses.jsx:246
msgid "{accountDisplay} (Media)"
msgstr "{accountDisplay} (Medien)"

#: src/pages/account-statuses.jsx:252
msgid "{accountDisplay} ({monthYear})"
msgstr "{accountDisplay} ({monthYear})"

#: src/pages/account-statuses.jsx:321
msgid "Clear filters"
msgstr "Filter leeren"

#: src/pages/account-statuses.jsx:324
msgid "Clear"
msgstr "Leeren"

#: src/pages/account-statuses.jsx:338
msgid "Showing post with replies"
msgstr "Beitrag mit Antworten anzeigen"

#: src/pages/account-statuses.jsx:343
msgid "+ Replies"
msgstr "+ Antworten"

#: src/pages/account-statuses.jsx:349
msgid "Showing posts without boosts"
msgstr "Zeige Posts ohne Boosts"

#: src/pages/account-statuses.jsx:354
msgid "- Boosts"
msgstr "- Boosts"

#: src/pages/account-statuses.jsx:360
msgid "Showing posts with media"
msgstr "Zeige Posts mit Medien"

#: src/pages/account-statuses.jsx:377
msgid "Showing posts tagged with #{0}"
msgstr "Zeige Posts mit #{0}"

#: src/pages/account-statuses.jsx:416
msgid "Showing posts in {0}"
msgstr "Zeige Posts in {0}"

#: src/pages/account-statuses.jsx:505
msgid "Nothing to see here yet."
msgstr "Noch nichts zu sehen."

#: src/pages/account-statuses.jsx:506
#: src/pages/public.jsx:97
#: src/pages/trending.jsx:449
msgid "Unable to load posts"
msgstr "Konnte Posts nicht laden"

#: src/pages/account-statuses.jsx:547
#: src/pages/account-statuses.jsx:577
msgid "Unable to fetch account info"
msgstr "Kontoinformationen konnten nicht abgerufen werden"

#: src/pages/account-statuses.jsx:554
msgid "Switch to account's instance {0}"
msgstr "Zur Kontoinstanz {0} wechseln"

#: src/pages/account-statuses.jsx:584
msgid "Switch to my instance (<0>{currentInstance}</0>)"
msgstr "Zu meiner Instanz wechseln (<0>{currentInstance}</0>)"

#: src/pages/account-statuses.jsx:646
msgid "Month"
msgstr "Monat"

#: src/pages/accounts.jsx:55
msgid "Current"
msgstr "Aktuell"

#: src/pages/accounts.jsx:101
msgid "Default"
msgstr "Standard"

#: src/pages/accounts.jsx:123
msgid "Switch to this account"
msgstr ""

#: src/pages/accounts.jsx:132
msgid "Switch in new tab/window"
msgstr ""

#: src/pages/accounts.jsx:146
msgid "View profile…"
msgstr "Profil anzeigen…"

#: src/pages/accounts.jsx:163
msgid "Set as default"
msgstr "Als Standard festlegen"

#: src/pages/accounts.jsx:173
msgid "Log out <0>@{0}</0>?"
msgstr ""

#: src/pages/accounts.jsx:196
msgid "Log out…"
msgstr "Abmelden…"

#: src/pages/accounts.jsx:209
msgid "Add an existing account"
msgstr "Bestehendes Konto hinzufügen"

#: src/pages/accounts.jsx:216
msgid "Note: <0>Default</0> account will always be used for first load. Switched accounts will persist during the session."
msgstr "Hinweis: <0>Standard</0>-Konten werden immer zum erstmaligen Laden verwendet werden. Zweitkonten werden während der Sitzung beibehalten werden."

#: src/pages/bookmarks.jsx:25
msgid "No bookmarks yet. Go bookmark something!"
msgstr ""

#: src/pages/bookmarks.jsx:26
msgid "Unable to load bookmarks."
msgstr "Lesezeichen konnten nicht geladen werden."

#: src/pages/catchup.jsx:54
msgid "last 1 hour"
msgstr "Letzte Stunde"

#: src/pages/catchup.jsx:55
msgid "last 2 hours"
msgstr "Letzte 2 Stunden"

#: src/pages/catchup.jsx:56
msgid "last 3 hours"
msgstr "Letzte 3 Stunden"

#: src/pages/catchup.jsx:57
msgid "last 4 hours"
msgstr "Letzte 4 Stunden"

#: src/pages/catchup.jsx:58
msgid "last 5 hours"
msgstr "Letzte 5 Stunden"

#: src/pages/catchup.jsx:59
msgid "last 6 hours"
msgstr "Letzte 6 Stunden"

#: src/pages/catchup.jsx:60
msgid "last 7 hours"
msgstr "Letzte 7 Stunden"

#: src/pages/catchup.jsx:61
msgid "last 8 hours"
msgstr "Letzte 8 Stunden"

#: src/pages/catchup.jsx:62
msgid "last 9 hours"
msgstr "Letzte 9 Stunden"

#: src/pages/catchup.jsx:63
msgid "last 10 hours"
msgstr "Letzte 10 Stunden"

#: src/pages/catchup.jsx:64
msgid "last 11 hours"
msgstr "Letzte 11 Stunden"

#: src/pages/catchup.jsx:65
msgid "last 12 hours"
msgstr "Letzte 12 Stunden"

#: src/pages/catchup.jsx:66
msgid "beyond 12 hours"
msgstr "Älter als 12 Stunden"

#: src/pages/catchup.jsx:73
msgid "Followed tags"
msgstr "Gefolgte Hashtags"

#: src/pages/catchup.jsx:74
msgid "Groups"
msgstr "Gruppen"

#: src/pages/catchup.jsx:596
msgid "Showing {selectedFilterCategory, select, all {all posts} original {original posts} replies {replies} boosts {boosts} followedTags {followed tags} groups {groups} filtered {filtered posts}}, {sortBy, select, createdAt {{sortOrder, select, asc {oldest} desc {latest}}} reblogsCount {{sortOrder, select, asc {fewest boosts} desc {most boosts}}} favouritesCount {{sortOrder, select, asc {fewest likes} desc {most likes}}} repliesCount {{sortOrder, select, asc {fewest replies} desc {most replies}}} density {{sortOrder, select, asc {least dense} desc {most dense}}}} first{groupBy, select, account {, grouped by authors} other {}}"
msgstr "Zeige {selectedFilterCategory, select, all {alle Beiträge} original {Originalbeiträge} replies {Antworten} boosts {geteilte Beiträge} followedTags {beobachtete Hashtags} groups {Gruppen} filtered {herausgefilterte Beiträge}},{sortBy, select, createdAt {{sortOrder, select, asc {älteste Beiträge} desc {neueste Beiträge}}} reblogsCount {{sortOrder, select, asc {am wenigsten geteilte Beiträge} desc {am meisten geteilte Beiträge}}} favouritesCount {{sortOrder, select, asc {wenigste Favoriten} desc {meiste Favoriten}}} repliesCount {{sortOrder, select, asc {wenigste Antworten} desc {meiste Antworten}}} density {{sortOrder, select, asc {am wenigsten dichte Beiträge} desc {dichteste Beiträge}}}} zuerst{groupBy, select, account {, nach Verfassern gruppiert} other {}}"

#: src/pages/catchup.jsx:882
#: src/pages/catchup.jsx:906
msgid "Catch-up <0>beta</0>"
msgstr ""

#: src/pages/catchup.jsx:896
#: src/pages/catchup.jsx:1585
msgid "Help"
msgstr "Hilfe"

#: src/pages/catchup.jsx:912
msgid "What is this?"
msgstr "Was ist das?"

#: src/pages/catchup.jsx:915
msgid "Catch-up is a separate timeline for your followings, offering a high-level view at a glance, with a simple, email-inspired interface to effortlessly sort and filter through posts."
msgstr "„Aufholen“ ist eine separate Timeline der Leute, denen du folgst. Sie ermöglicht es dir, auf einen Blick zu sehen, was du verpasst hast, mit einer einfachen, an E-Mails erinnernden Oberfläche, um mühelos Beiträge zu sortieren und zu filtern."

#: src/pages/catchup.jsx:926
msgid "Preview of Catch-up UI"
msgstr "Vorschau der Aufholen-Oberfläche"

#: src/pages/catchup.jsx:935
msgid "Let's catch up"
msgstr "Jetzt aufholen"

#: src/pages/catchup.jsx:940
msgid "Let's catch up on the posts from your followings."
msgstr "Lass’ uns mit Beiträgen aufholen, deren Verfassern du folgst."

#: src/pages/catchup.jsx:944
msgid "Show me all posts from…"
msgstr "Alle Posts von… anzeigen"

#: src/pages/catchup.jsx:967
msgid "until the max"
msgstr "bis zum Maximum"

#: src/pages/catchup.jsx:997
msgid "Catch up"
msgstr "Aufholen"

#: src/pages/catchup.jsx:1003
msgid "Overlaps with your last catch-up"
msgstr "Überlappt mit deinem letzten Aufholen"

#: src/pages/catchup.jsx:1015
msgid "Until the last catch-up ({0})"
msgstr "Bis zum letzten Aufholen ({0})"

#: src/pages/catchup.jsx:1024
msgid "Note: your instance might only show a maximum of 800 posts in the Home timeline regardless of the time range. Could be less or more."
msgstr "Hinweis: Deine Instanz zeigt ggf. höchstens 800 Beiträge in deiner Home-Timeline an, unabhängig vom Zeitrahmen. Könnte variieren."

#: src/pages/catchup.jsx:1034
msgid "Previously…"
msgstr "Zuvor…"

#: src/pages/catchup.jsx:1052
msgid "{0, plural, one {# post} other {# posts}}"
msgstr "{0, plural, one {# Beitrag} other {# Beiträge}}"

#: src/pages/catchup.jsx:1062
msgid "Remove this catch-up?"
msgstr "Dieses Aufholen entfernen?"

#: src/pages/catchup.jsx:1065
msgid "Removing Catch-up {0}"
msgstr ""

#: src/pages/catchup.jsx:1069
msgid "Catch-up {0} removed"
msgstr ""

#: src/pages/catchup.jsx:1083
msgid "Note: Only max 3 will be stored. The rest will be automatically removed."
msgstr "Hinweis: Höchstens 3 werden gespeichert werden. Der Rest wird automatisch entfernt werden."

#: src/pages/catchup.jsx:1098
msgid "Fetching posts…"
msgstr "Lade Posts…"

#: src/pages/catchup.jsx:1101
msgid "This might take a while."
msgstr "Dies könnte eine Weile dauern."

#: src/pages/catchup.jsx:1136
msgid "Reset filters"
msgstr "Filter zurücksetzen"

#: src/pages/catchup.jsx:1144
#: src/pages/catchup.jsx:1591
msgid "Top links"
msgstr "Häufigste Links"

#: src/pages/catchup.jsx:1261
msgid "Shared by {0}"
msgstr "Geteilt von {0}"

#: src/pages/catchup.jsx:1316
#: src/pages/mentions.jsx:147
#: src/pages/search.jsx:297
msgid "All"
msgstr "Alle"

#: src/pages/catchup.jsx:1401
msgid "{0, plural, one {# author} other {# authors}}"
msgstr "{0, plural, one {# Autor} other {# Autoren}}"

#: src/pages/catchup.jsx:1413
msgid "Sort"
msgstr "Sortieren"

#: src/pages/catchup.jsx:1444
msgid "Date"
msgstr "Datum"

#: src/pages/catchup.jsx:1448
msgid "Density"
msgstr "Dichte"

#. js-lingui-explicit-id
#: src/pages/catchup.jsx:1471
msgid "group.filter"
msgstr ""

#: src/pages/catchup.jsx:1486
msgid "Authors"
msgstr "Autoren"

#: src/pages/catchup.jsx:1487
msgid "None"
msgstr "Keine"

#: src/pages/catchup.jsx:1503
msgid "Show all authors"
msgstr "Alle Autoren anzeigen"

#: src/pages/catchup.jsx:1554
msgid "You don't have to read everything."
msgstr "Sie müssen nicht alles lesen."

#: src/pages/catchup.jsx:1555
msgid "That's all."
msgstr "Das ist alles."

#: src/pages/catchup.jsx:1563
msgid "Back to top"
msgstr "Zurück zum Anfang"

#: src/pages/catchup.jsx:1594
msgid "Links shared by followings, sorted by shared counts, boosts and likes."
msgstr "Links, die von Leuten geteilt wurden, denen du folgst; sortiert nach Häufigkeit sowie nach Boost- und Favoriten-Anzahlen."

#: src/pages/catchup.jsx:1600
msgid "Sort: Density"
msgstr "Sortieren: Dichte"

#: src/pages/catchup.jsx:1603
msgid "Posts are sorted by information density or depth. Shorter posts are \"lighter\" while longer posts are \"heavier\". Posts with photos are \"heavier\" than posts without photos."
msgstr "Beiträge werden nach Parametern wie Dichte oder Tiefe sortiert. Kürzere Beiträge sind „leichter“, während längere Beiträge „schwerer“ sind. Außerdem sind Beiträge mit Fotos „schwerer“ als solche ohne Fotos."

#: src/pages/catchup.jsx:1610
msgid "Group: Authors"
msgstr "Gruppieren: Autoren"

#: src/pages/catchup.jsx:1613
msgid "Posts are grouped by authors, sorted by posts count per author."
msgstr "Beiträge werden nach Autoren gruppiert, sortiert nach Anzahl der Beiträge pro Autor."

#: src/pages/catchup.jsx:1660
msgid "Next author"
msgstr "Nächster Autor"

#: src/pages/catchup.jsx:1668
msgid "Previous author"
msgstr "Vorheriger Autor"

#: src/pages/catchup.jsx:1684
msgid "Scroll to top"
msgstr "Zum Anfang scrollen"

#: src/pages/catchup.jsx:1875
msgid "Filtered: {0}"
msgstr "Gefiltert: {0}"

#: src/pages/favourites.jsx:25
msgid "No likes yet. Go like something!"
msgstr ""

#: src/pages/favourites.jsx:26
msgid "Unable to load likes."
msgstr "Favoriten können nicht geladen werden."

#: src/pages/filters.jsx:23
msgid "Home and lists"
msgstr "Startseite und Listen"

#: src/pages/filters.jsx:25
msgid "Public timelines"
msgstr "Öffentliche Timelines"

#: src/pages/filters.jsx:26
msgid "Conversations"
msgstr "Unterhaltungen"

#: src/pages/filters.jsx:27
msgid "Profiles"
msgstr "Profile"

#: src/pages/filters.jsx:42
msgid "Never"
msgstr "Nie"

#: src/pages/filters.jsx:103
#: src/pages/filters.jsx:228
msgid "New filter"
msgstr "Neuer Filter"

#: src/pages/filters.jsx:151
msgid "{0, plural, one {# filter} other {# filters}}"
msgstr "{0, plural, one {# Filter} other {# Filter}}"

#: src/pages/filters.jsx:166
msgid "Unable to load filters."
msgstr "Filter konnten nicht geladen werden."

#: src/pages/filters.jsx:170
msgid "No filters yet."
msgstr "Noch keine Filter."

#: src/pages/filters.jsx:177
msgid "Add filter"
msgstr "Filter hinzufügen"

#: src/pages/filters.jsx:228
msgid "Edit filter"
msgstr "Filter bearbeiten"

#: src/pages/filters.jsx:345
msgid "Unable to edit filter"
msgstr "Filter konnte nicht bearbeitet werden"

#: src/pages/filters.jsx:346
msgid "Unable to create filter"
msgstr "Filter konnte nicht erstellt werden"

#: src/pages/filters.jsx:355
msgid "Title"
msgstr "Titel"

#: src/pages/filters.jsx:396
msgid "Whole word"
msgstr "Ganzes Wort"

#: src/pages/filters.jsx:422
msgid "No keywords. Add one."
msgstr "Keine Schlüsselwörter. Füge eines hinzu."

#: src/pages/filters.jsx:449
msgid "Add keyword"
msgstr "Schlüsselwort hinzufügen"

#: src/pages/filters.jsx:453
msgid "{0, plural, one {# keyword} other {# keywords}}"
msgstr "{0, plural, one {# Schlüsselwort} other {# Schlüsselwörter}}"

#: src/pages/filters.jsx:466
msgid "Filter from…"
msgstr "Filtern von…"

#: src/pages/filters.jsx:492
msgid "* Not implemented yet"
msgstr "* Noch nicht implementiert"

#: src/pages/filters.jsx:498
msgid "Status: <0><1/></0>"
msgstr "Status: <0><1/></0>"

#: src/pages/filters.jsx:507
msgid "Change expiry"
msgstr "Ablaufdatum ändern"

#: src/pages/filters.jsx:507
msgid "Expiry"
msgstr "Ablaufdatum"

#: src/pages/filters.jsx:526
msgid "Filtered post will be…"
msgstr "Gefilterter Post wird…"

#: src/pages/filters.jsx:536
msgid "minimized"
msgstr "minimiert"

#: src/pages/filters.jsx:546
msgid "hidden"
msgstr "ausgeblendet"

#: src/pages/filters.jsx:563
msgid "Delete this filter?"
msgstr "Diesen Filter löschen?"

#: src/pages/filters.jsx:576
msgid "Unable to delete filter."
msgstr "Filter konnte nicht gelöscht werden."

#: src/pages/filters.jsx:608
msgid "Expired"
msgstr "Abgelaufen"

#: src/pages/filters.jsx:610
msgid "Expiring <0/>"
msgstr "Läuft ab <0/>"

#: src/pages/filters.jsx:614
msgid "Never expires"
msgstr "Läuft nie ab"

#: src/pages/followed-hashtags.jsx:70
msgid "{0, plural, one {# hashtag} other {# hashtags}}"
msgstr "{0, plural, one {# Hashtag} other {# Hashtags}}"

#: src/pages/followed-hashtags.jsx:85
msgid "Unable to load followed hashtags."
msgstr "Gefolgte Hashtags konnten nicht geladen werden."

#: src/pages/followed-hashtags.jsx:89
msgid "No hashtags followed yet."
msgstr "Noch keine Hashtags gefolgt."

#: src/pages/following.jsx:143
msgid "Nothing to see here."
msgstr "Hier gibt es nichts zu sehen."

#: src/pages/following.jsx:144
#: src/pages/list.jsx:108
msgid "Unable to load posts."
msgstr "Konnte Posts nicht laden."

#: src/pages/hashtag.jsx:55
msgid "{hashtagTitle} (Media only) on {instance}"
msgstr "{hashtagTitle} (nur Medien) auf {instance}"

#: src/pages/hashtag.jsx:56
msgid "{hashtagTitle} on {instance}"
msgstr "{hashtagTitle} auf {instance}"

#: src/pages/hashtag.jsx:58
msgid "{hashtagTitle} (Media only)"
msgstr "{hashtagTitle} (nur Medien)"

#: src/pages/hashtag.jsx:59
msgid "{hashtagTitle}"
msgstr "{hashtagTitle}"

#: src/pages/hashtag.jsx:181
msgid "No one has posted anything with this tag yet."
msgstr "Noch niemand hat etwas mit diesem Tag gepostet."

#: src/pages/hashtag.jsx:182
msgid "Unable to load posts with this tag"
msgstr "Konnte Posts mit diesem Tag nicht laden"

#: src/pages/hashtag.jsx:208
msgid "Unfollow #{hashtag}?"
msgstr ""

#: src/pages/hashtag.jsx:223
msgid "Unfollowed #{hashtag}"
msgstr "#{hashtag} entfolgt"

#: src/pages/hashtag.jsx:238
msgid "Followed #{hashtag}"
msgstr "#{hashtag} gefolgt"

#: src/pages/hashtag.jsx:254
msgid "Following…"
msgstr "Folgt…"

#: src/pages/hashtag.jsx:282
msgid "Unfeatured on profile"
msgstr "Nicht mehr auf Profil vorgestellt"

#: src/pages/hashtag.jsx:296
msgid "Unable to unfeature on profile"
msgstr "Nicht möglich, das Vorstellen auf dem Profil rückgängig zu machen"

#: src/pages/hashtag.jsx:305
#: src/pages/hashtag.jsx:321
msgid "Featured on profile"
msgstr "Auf Profil vorgestellt"

#: src/pages/hashtag.jsx:328
msgid "Feature on profile"
msgstr "Auf Profil vorstellen"

#: src/pages/hashtag.jsx:393
msgid "{TOTAL_TAGS_LIMIT, plural, other {Max # tags}}"
msgstr "{TOTAL_TAGS_LIMIT, plural, one {}other {Höchstens # Hashtags}}"

#: src/pages/hashtag.jsx:396
msgid "Add hashtag"
msgstr "Hashtag hinzufügen"

#: src/pages/hashtag.jsx:428
msgid "Remove hashtag"
msgstr "Hashtag entfernen"

#: src/pages/hashtag.jsx:442
msgid "{SHORTCUTS_LIMIT, plural, one {Max # shortcut reached. Unable to add shortcut.} other {Max # shortcuts reached. Unable to add shortcut.}}"
msgstr "{SHORTCUTS_LIMIT, plural, one {Höchstanzahl (#) an Verknüpfungen erreicht.} other {Höchstanzahl (#) an Verknüpfungen erreicht. Weitere Verknüpfung kann nicht hinzugefügt werden.}}"

#: src/pages/hashtag.jsx:471
msgid "This shortcut already exists"
msgstr "Diese Verknüpfung existiert bereits"

#: src/pages/hashtag.jsx:474
msgid "Hashtag shortcut added"
msgstr "Hashtag-Verknüpfung hinzugefügt"

#: src/pages/hashtag.jsx:480
msgid "Add to Shortcuts"
msgstr "Zu Verknüpfungen hinzufügen"

#: src/pages/hashtag.jsx:486
#: src/pages/public.jsx:139
#: src/pages/trending.jsx:478
msgid "Enter a new instance e.g. \"mastodon.social\""
msgstr "Geben Sie eine neue Instanz ein, z.B. \"mastodon.social\""

#: src/pages/hashtag.jsx:489
#: src/pages/public.jsx:142
#: src/pages/trending.jsx:481
msgid "Invalid instance"
msgstr "Ungültige Instanz"

#: src/pages/hashtag.jsx:503
#: src/pages/public.jsx:156
#: src/pages/trending.jsx:493
msgid "Go to another instance…"
msgstr "Gehe zu einer anderen Instanz…"

#: src/pages/hashtag.jsx:516
#: src/pages/public.jsx:169
#: src/pages/trending.jsx:504
msgid "Go to my instance (<0>{currentInstance}</0>)"
msgstr "Zu meiner Instanz (<0>{currentInstance}</0>) gehen"

#: src/pages/home.jsx:209
msgid "Unable to fetch notifications."
msgstr "Benachrichtigungen konnten nicht geladen werden."

#: src/pages/home.jsx:229
msgid "<0>New</0> <1>Follow Requests</1>"
msgstr "<0>Neue</0> <1>Folge-Anfragen</1>"

#: src/pages/home.jsx:235
msgid "See all"
msgstr "Alle anzeigen"

#: src/pages/http-route.jsx:68
msgid "Resolving…"
msgstr "Auflösen…"

#: src/pages/http-route.jsx:79
msgid "Unable to resolve URL"
msgstr "URL konnte nicht aufgelöst werden"

#: src/pages/list.jsx:107
msgid "Nothing yet."
msgstr "Noch nichts."

#: src/pages/list.jsx:176
#: src/pages/list.jsx:279
msgid "Manage members"
msgstr "Mitglieder verwalten"

#: src/pages/list.jsx:313
msgid "Remove <0>@{0}</0> from list?"
msgstr ""

#: src/pages/list.jsx:359
msgid "Remove…"
msgstr "Entferne…"

#: src/pages/lists.jsx:93
msgid "{0, plural, one {# list} other {# lists}}"
msgstr "{0, plural, one {# Filter} other {# Filter}}"

#: src/pages/lists.jsx:108
msgid "No lists yet."
msgstr "Noch keine Listen."

#: src/pages/login.jsx:109
#: src/pages/login.jsx:122
msgid "Failed to register application"
msgstr ""

#: src/pages/login.jsx:208
msgid "instance domain"
msgstr ""

#: src/pages/login.jsx:232
msgid "e.g. “mastodon.social”"
msgstr "z.B. “mastodon.social”"

#: src/pages/login.jsx:243
msgid "Failed to log in. Please try again or try another instance."
msgstr ""

#: src/pages/login.jsx:255
msgid "Continue with {selectedInstanceText}"
msgstr "Mit {selectedInstanceText} fortfahren"

#: src/pages/login.jsx:256
msgid "Continue"
msgstr "Weiter"

#: src/pages/login.jsx:264
msgid "Don't have an account? Create one!"
msgstr "Sie haben noch kein Konto? Erstellen Sie eines!"

#: src/pages/mentions.jsx:20
msgid "Private mentions"
msgstr "Private Erwähnungen"

#: src/pages/mentions.jsx:159
msgid "Private"
msgstr "Privat"

#: src/pages/mentions.jsx:169
msgid "No one mentioned you :("
msgstr "Niemand hat Sie erwähnt :("

#: src/pages/mentions.jsx:170
msgid "Unable to load mentions."
msgstr "Erwähnungen konnten nicht geladen werden."

#: src/pages/notifications.jsx:103
msgid "You don't follow"
msgstr "Sie folgen nicht"

#: src/pages/notifications.jsx:104
msgid "Who don't follow you"
msgstr "Wer Ihnen nicht folgt"

#: src/pages/notifications.jsx:105
msgid "With a new account"
msgstr "Mit einem neuen Konto"

#: src/pages/notifications.jsx:106
msgid "Who unsolicitedly private mention you"
msgstr "Wer dich unaufgefordert privat anschreibt"

#: src/pages/notifications.jsx:107
msgid "Who are limited by server moderators"
msgstr "Wer von Servermoderatoren eingeschränkt wurde"

#: src/pages/notifications.jsx:538
#: src/pages/notifications.jsx:872
msgid "Notifications settings"
msgstr "Benachrichtigungseinstellungen"

#: src/pages/notifications.jsx:556
msgid "New notifications"
msgstr "Neue Benachrichtigungen"

#: src/pages/notifications.jsx:567
msgid "{0, plural, one {Announcement} other {Announcements}}"
msgstr "{0, plural, one {Bekanntmachung} other {Bekanntmachungen}}"

#: src/pages/notifications.jsx:614
#: src/pages/settings.jsx:1118
msgid "Follow requests"
msgstr "Folgeanfragen"

#: src/pages/notifications.jsx:619
msgid "{0, plural, one {# follow request} other {# follow requests}}"
msgstr "{0, plural, one {# Folge-Anfrage} other {# Folge-Anfragen}}"

#: src/pages/notifications.jsx:674
msgid "{0, plural, one {Filtered notifications from # person} other {Filtered notifications from # people}}"
msgstr "{0, plural, one {Benachrichtigungen von # Person herausgefiltert} other {Benachrichtigungen von # Leuten herausgefiltert}}"

#: src/pages/notifications.jsx:740
msgid "Only mentions"
msgstr "Nur Erwähnungen"

#: src/pages/notifications.jsx:744
msgid "Today"
msgstr "Heute"

#: src/pages/notifications.jsx:749
msgid "You're all caught up."
msgstr "Sie sind auf dem neuesten Stand."

#: src/pages/notifications.jsx:772
msgid "Yesterday"
msgstr "Gestern"

#: src/pages/notifications.jsx:820
msgid "Unable to load notifications"
msgstr "Benachrichtigungen konnten nicht geladen werden"

#: src/pages/notifications.jsx:899
msgid "Notifications settings updated"
msgstr "Benachrichtigungseinstellungen aktualisiert"

#: src/pages/notifications.jsx:907
msgid "Filter out notifications from people:"
msgstr "Benachrichtigungen von Personen ausfiltern:"

#: src/pages/notifications.jsx:921
msgid "Filter"
msgstr "Filtern"

#: src/pages/notifications.jsx:924
msgid "Ignore"
msgstr "Ignorieren"

#: src/pages/notifications.jsx:997
msgid "Updated <0>{0}</0>"
msgstr "Aktualisiert <0>{0}</0>"

#: src/pages/notifications.jsx:1065
msgid "View notifications from <0>@{0}</0>"
msgstr ""

#: src/pages/notifications.jsx:1086
msgid "Notifications from <0>@{0}</0>"
msgstr ""

#: src/pages/notifications.jsx:1153
msgid "Notifications from @{0} will not be filtered from now on."
msgstr "Benachrichtigungen von @{0} werden von jetzt an nicht herausgefiltert."

#: src/pages/notifications.jsx:1158
msgid "Unable to accept notification request"
msgstr "Unmöglich, die Benachrichtigungsanfrage anzunehmen"

#: src/pages/notifications.jsx:1163
msgid "Allow"
msgstr "Zulassen"

#: src/pages/notifications.jsx:1183
msgid "Notifications from @{0} will not show up in Filtered notifications from now on."
msgstr "Benachrichtigungen von @{0} werden ab jetzt nicht mehr in gefilterten Benachrichtigungen angezeigt."

#: src/pages/notifications.jsx:1188
msgid "Unable to dismiss notification request"
msgstr "Benachrichtigungsanfrage konnte nicht ausgeblendet werden"

#: src/pages/notifications.jsx:1193
msgid "Dismiss"
msgstr "Verwerfen"

#: src/pages/notifications.jsx:1208
msgid "Dismissed"
msgstr "Verworfen"

#: src/pages/public.jsx:27
msgid "Local timeline ({instance})"
msgstr "Lokale Zeitleiste ({instance})"

#: src/pages/public.jsx:28
msgid "Federated timeline ({instance})"
msgstr "Föderierte Zeitleiste ({instance})"

#: src/pages/public.jsx:90
msgid "Local timeline"
msgstr "Lokale Zeitleiste"

#: src/pages/public.jsx:90
msgid "Federated timeline"
msgstr "Föderierte Zeitleiste"

#: src/pages/public.jsx:96
msgid "No one has posted anything yet."
msgstr "Noch niemand hat etwas gepostet."

#: src/pages/public.jsx:123
msgid "Switch to Federated"
msgstr "Zu Föderiert wechseln"

#: src/pages/public.jsx:130
msgid "Switch to Local"
msgstr "Zu Lokal wechseln"

#: src/pages/search.jsx:49
msgid "Search: {q} (Posts)"
msgstr "Suche: {q} (Posts)"

#: src/pages/search.jsx:52
msgid "Search: {q} (Accounts)"
msgstr "Suche: {q} (Konten)"

#: src/pages/search.jsx:55
msgid "Search: {q} (Hashtags)"
msgstr "Suche: {q} (Hashtags)"

#: src/pages/search.jsx:58
msgid "Search: {q}"
msgstr "Suche: {q}"

#: src/pages/search.jsx:307
#: src/pages/search.jsx:389
msgid "Hashtags"
msgstr "Hashtags"

#: src/pages/search.jsx:339
#: src/pages/search.jsx:393
#: src/pages/search.jsx:463
msgid "See more"
msgstr "Mehr anzeigen"

#: src/pages/search.jsx:365
msgid "See more accounts"
msgstr "Weitere Konten anzeigen"

#: src/pages/search.jsx:379
msgid "No accounts found."
msgstr "Keine Konten gefunden."

#: src/pages/search.jsx:435
msgid "See more hashtags"
msgstr "Mehr Hashtags anzeigen"

#: src/pages/search.jsx:449
msgid "No hashtags found."
msgstr "Keine Hashtags gefunden."

#: src/pages/search.jsx:493
msgid "See more posts"
msgstr "Mehr Posts anzeigen"

#: src/pages/search.jsx:507
msgid "No posts found."
msgstr "Keine Posts gefunden."

#: src/pages/search.jsx:551
msgid "Enter your search term or paste a URL above to get started."
msgstr "Geben Sie Ihren Suchbegriff ein oder fügen Sie oben eine URL ein, um zu beginnen."

#: src/pages/settings.jsx:81
msgid "Settings"
msgstr "Einstellungen"

#: src/pages/settings.jsx:90
msgid "Appearance"
msgstr "Erscheinungsbild"

#: src/pages/settings.jsx:166
msgid "Light"
msgstr "Hell"

#: src/pages/settings.jsx:177
msgid "Dark"
msgstr "Dunkel"

#: src/pages/settings.jsx:190
msgid "Auto"
msgstr "Automatisch"

#: src/pages/settings.jsx:200
msgid "Text size"
msgstr "Textgröße"

#. Preview of one character, in smallest size
#. Preview of one character, in largest size
#: src/pages/settings.jsx:205
#: src/pages/settings.jsx:230
msgid "A"
msgstr "A"

#: src/pages/settings.jsx:244
msgid "Display language"
msgstr "Anzeigesprache"

#: src/pages/settings.jsx:253
msgid "Volunteer translations"
msgstr ""

#: src/pages/settings.jsx:264
msgid "Posting"
msgstr "Posten"

#: src/pages/settings.jsx:271
msgid "Default visibility"
msgstr "Standardsichtbarkeit"

#: src/pages/settings.jsx:272
#: src/pages/settings.jsx:318
msgid "Synced"
msgstr "Synchronisiert"

#: src/pages/settings.jsx:297
msgid "Failed to update posting privacy"
msgstr "Aktualisieren der Beitragssichtbarkeit fehlgeschlagen"

#: src/pages/settings.jsx:320
msgid "Synced to your instance server's settings. <0>Go to your instance ({instance}) for more settings.</0>"
msgstr "Mit den Einstellungen deines Instanzservers synchronisiert. <0>Gehe zur Instanz ({instance}) für weitere Einstellungen.</0>"

#: src/pages/settings.jsx:335
msgid "Experiments"
msgstr "Experimentelle Funktionen"

#: src/pages/settings.jsx:348
msgid "Auto refresh timeline posts"
msgstr "Zeitleiste automatisch aktualisieren"

#: src/pages/settings.jsx:360
msgid "Boosts carousel"
msgstr "Boost Karussell"

#: src/pages/settings.jsx:376
msgid "Post translation"
msgstr "Post-Übersetzung"

#: src/pages/settings.jsx:387
msgid "Translate to"
msgstr "Übersetze zu"

#: src/pages/settings.jsx:398
msgid "System language ({systemTargetLanguageText})"
msgstr "Systemsprache ({systemTargetLanguageText})"

#: src/pages/settings.jsx:424
msgid "{0, plural, =0 {Hide \"Translate\" button for:} other {Hide \"Translate\" button for (#):}}"
msgstr "{0, plural, =0 {Verstecke „Übersetzen“-Button für:} other {Verstecke „Übersetzen“-Button für (#):}}"

#: src/pages/settings.jsx:478
msgid "Note: This feature uses external translation services, powered by <0>Lingva API</0> & <1>Lingva Translate</1>."
msgstr "Hinweis: Diese Funktion verwendet externe Übersetzungsdienste, ermöglicht durch <0>Lingva-API</0> & <1>Lingva Translate</1>."

#: src/pages/settings.jsx:512
msgid "Auto inline translation"
msgstr "Automatische Inline-Übersetzung"

#: src/pages/settings.jsx:516
msgid "Automatically show translation for posts in timeline. Only works for <0>short</0> posts without content warning, media and poll."
msgstr "Übersetzung für Beiträge automatisch in der Zeitleiste anzeigen. Funktioniert nur für <0>kurze</0> Beiträge ohne Inhaltswarnung, Medien und Umfragen."

#: src/pages/settings.jsx:536
msgid "GIF Picker for composer"
msgstr "GIF-Wähler für Verfassen-Fenster"

#: src/pages/settings.jsx:540
msgid "Note: This feature uses external GIF search service, powered by <0>GIPHY</0>. G-rated (suitable for viewing by all ages), tracking parameters are stripped, referrer information is omitted from requests, but search queries and IP address information will still reach their servers."
msgstr "Hinweis: Diese Funktion verwendet einen externen GIF-Suchdienst, ermöglicht durch <0>GIPHY</0>. Angemessen für alle Altersgruppen, Tracking-Parameter werden entfernt, Referrer-Informationen werden bei Anfragen ausgelassen, aber Suchbegriffe und die IP-Adresse werden an deren Server übertragen."

#: src/pages/settings.jsx:569
msgid "Image description generator"
msgstr "Bildbeschreibungsgenerator"

#: src/pages/settings.jsx:574
msgid "Only for new images while composing new posts."
msgstr "Nur für neue Bilder beim Erstellen neuer Posts."

#: src/pages/settings.jsx:581
msgid "Note: This feature uses external AI service, powered by <0>img-alt-api</0>. May not work well. Only for images and in English."
msgstr "Hinweis: Diese Funktion verwendet einen externen KI-Dienst, ermöglicht durch <0>img-alt-api</0>. Könnte durchwachsen funktionieren. Nur für Bilder und nur auf Englisch."

#: src/pages/settings.jsx:607
msgid "Server-side grouped notifications"
msgstr "Serverseitig gruppierte Benachrichtigungen"

#: src/pages/settings.jsx:611
msgid "Alpha-stage feature. Potentially improved grouping window but basic grouping logic."
msgstr "Alpha-Funktion. Möglicherweise verbessertes Gruppierungsfenster, aber nur grundlegende Gruppierungslogik."

#: src/pages/settings.jsx:632
msgid "\"Cloud\" import/export for shortcuts settings"
msgstr "„Cloud“-Import/-Export für Verknüpfungseinstellungen"

#: src/pages/settings.jsx:637
msgid "⚠️⚠️⚠️ Very experimental.<0/>Stored in your own profile’s notes. Profile (private) notes are mainly used for other profiles, and hidden for own profile."
msgstr "⚠️⚠️⚠️ Hochgradig experimentell.<0/>Wird in deinen eigenen Profilnotizen gespeichert. (Private) Profilnotizen werden hauptsächlich für andere Profile verwendet und für das eigene Profil versteckt."

#: src/pages/settings.jsx:648
msgid "Note: This feature uses currently-logged-in instance server API."
msgstr "Hinweis: Diese Funktion verwendet die aktuell eingeloggte Instanz-API des Servers."

#: src/pages/settings.jsx:665
msgid "Cloak mode <0>(<1>Text</1> → <2>████</2>)</0>"
msgstr "Cloak Modus <0>(<1>Text</1> → <2>████</2>)</0>"

#: src/pages/settings.jsx:674
msgid "Replace text as blocks, useful when taking screenshots, for privacy reasons."
msgstr "Text durch Blöcke ersetzen, nützlich für Screenshots, aus Datenschutzgründen."

#: src/pages/settings.jsx:699
msgid "About"
msgstr "Über"

#: src/pages/settings.jsx:738
msgid "<0>Built</0> by <1>@cheeaun</1>"
msgstr "<0>Entwickelt</0> von <1>@cheeaun</1>"

#: src/pages/settings.jsx:767
msgid "Sponsor"
msgstr "Sponsor"

#: src/pages/settings.jsx:775
msgid "Donate"
msgstr "Spenden"

#: src/pages/settings.jsx:783
msgid "Privacy Policy"
msgstr "Datenschutzerklärung"

#: src/pages/settings.jsx:790
msgid "<0>Site:</0> {0}"
msgstr "<0>Seite:</0> {0}"

#: src/pages/settings.jsx:797
msgid "<0>Version:</0> <1/> {0}"
msgstr "<0>Version:</0> <1/> {0}"

#: src/pages/settings.jsx:812
msgid "Version string copied"
msgstr "Version kopiert"

#: src/pages/settings.jsx:815
msgid "Unable to copy version string"
msgstr "Version kann nicht kopiert werden"

#: src/pages/settings.jsx:1015
#: src/pages/settings.jsx:1020
msgid "Failed to update subscription. Please try again."
msgstr "Fehler beim Aktualisieren des Abonnements. Bitte versuchen Sie es erneut."

#: src/pages/settings.jsx:1026
msgid "Failed to remove subscription. Please try again."
msgstr "Fehler beim Entfernen des Abonnements. Bitte versuchen Sie es erneut."

#: src/pages/settings.jsx:1033
msgid "Push Notifications (beta)"
msgstr "Push-Benachrichtigungen (Beta)"

#: src/pages/settings.jsx:1055
msgid "Push notifications are blocked. Please enable them in your browser settings."
msgstr "Push-Benachrichtigungen sind blockiert. Bitte aktivieren Sie diese in Ihren Browsereinstellungen."

#: src/pages/settings.jsx:1064
msgid "Allow from <0>{0}</0>"
msgstr "Von <0>{0}</0> erlauben"

#: src/pages/settings.jsx:1073
msgid "anyone"
msgstr "Jeder"

#: src/pages/settings.jsx:1077
msgid "people I follow"
msgstr "Leuten, denen ich folge"

#: src/pages/settings.jsx:1081
msgid "followers"
msgstr "folgende"

#: src/pages/settings.jsx:1114
msgid "Follows"
msgstr "Folgt"

#: src/pages/settings.jsx:1122
msgid "Polls"
msgstr "Umfragen"

#: src/pages/settings.jsx:1126
msgid "Post edits"
msgstr "Post Bearbeitungen"

#: src/pages/settings.jsx:1147
msgid "Push permission was not granted since your last login. You'll need to <0><1>log in</1> again to grant push permission</0>."
msgstr "Push-Berechtigung wurde seit deinem letzten Login nicht erteilt. Sie müssen sich erneut <0><1>Anmelden</1>, um Push-Berechtigungen zu erteilen</0>."

#: src/pages/settings.jsx:1163
msgid "NOTE: Push notifications only work for <0>one account</0>."
msgstr "HINWEIS: Push-Benachrichtigungen funktionieren nur für <0>ein Konto</0>."

#. js-lingui-explicit-id
#: src/pages/status.jsx:597
#: src/pages/status.jsx:1131
msgid "post.title"
msgstr ""

#: src/pages/status.jsx:822
msgid "You're not logged in. Interactions (reply, boost, etc) are not possible."
msgstr "Sie sind nicht eingeloggt. Interaktionen (Antworten, Boost usw.) sind nicht möglich."

#: src/pages/status.jsx:842
msgid "This post is from another instance (<0>{instance}</0>). Interactions (reply, boost, etc) are not possible."
msgstr "Dieser Post stammt von einer anderen Instanz (<0>{instance}</0>). Interaktionen (Antworten, Boost, usw.) sind nicht möglich."

#: src/pages/status.jsx:870
msgid "Error: {e}"
msgstr "Fehler: {e}"

#: src/pages/status.jsx:877
msgid "Switch to my instance to enable interactions"
msgstr "Zu meiner Instanz wechseln, um Interaktionen zu ermöglichen"

#: src/pages/status.jsx:979
msgid "Unable to load replies."
msgstr "Antworten konnten nicht geladen werden."

#: src/pages/status.jsx:1091
msgid "Back"
msgstr "Zurück"

#: src/pages/status.jsx:1122
msgid "Go to main post"
msgstr "Zum Hauptbeitrag gehen"

#: src/pages/status.jsx:1145
msgid "{0} posts above ‒ Go to top"
msgstr "{0} Posts oberhalb ‒ Gehe nach oben"

#: src/pages/status.jsx:1188
#: src/pages/status.jsx:1251
msgid "Switch to Side Peek view"
msgstr "In der seitlichen Ansicht linsen"

#: src/pages/status.jsx:1252
msgid "Switch to Full view"
msgstr "Zur Vollansicht wechseln"

#: src/pages/status.jsx:1270
msgid "Show all sensitive content"
msgstr "Alle sensiblen Inhalte anzeigen"

#: src/pages/status.jsx:1275
msgid "Experimental"
msgstr "Experimentell"

#: src/pages/status.jsx:1284
msgid "Unable to switch"
msgstr "Wechsel nicht möglich"

#: src/pages/status.jsx:1291
msgid "Switch to post's instance ({0})"
msgstr "Zur Instanz des Posts wechseln ({0})"

#: src/pages/status.jsx:1294
msgid "Switch to post's instance"
msgstr "Zur Instanz des Posts wechseln"

#: src/pages/status.jsx:1352
msgid "Unable to load post"
msgstr "Post konnte nicht geladen werden"

#: src/pages/status.jsx:1487
msgid "{0, plural, one {# reply} other {<0>{1}</0> replies}}"
msgstr "{0, plural, one {# Antwort} other {<0>{1}</0> Antworten}}"

#: src/pages/status.jsx:1505
msgid "{totalComments, plural, one {# comment} other {<0>{0}</0> comments}}"
msgstr "{totalComments, plural, one {# Kommentar} other {<0>{0}</0> Kommentare}}"

#: src/pages/status.jsx:1527
msgid "View post with its replies"
msgstr "Post mit Antworten anzeigen"

#: src/pages/trending.jsx:71
msgid "Trending ({instance})"
msgstr "Angesagt ({instance})"

#: src/pages/trending.jsx:228
msgid "Trending News"
msgstr "Angesagte Nachrichten"

#. By [Author]
#: src/pages/trending.jsx:347
msgid "By {0}"
msgstr ""

#: src/pages/trending.jsx:408
msgid "Back to showing trending posts"
msgstr "Zurück zur Anzeige angesagter Posts"

#: src/pages/trending.jsx:413
msgid "Showing posts mentioning <0>{0}</0>"
msgstr "Zeige Posts in denen <0>{0}</0> erwähnt wird"

#: src/pages/trending.jsx:425
msgid "Trending posts"
msgstr "Angesagte Posts"

#: src/pages/trending.jsx:448
msgid "No trending posts."
msgstr "Keine angesagten Posts."

#: src/pages/welcome.jsx:53
msgid "A minimalistic opinionated Mastodon web client."
msgstr "Ein minimalistischer, dogmatischer Mastodon Web-Client."

#: src/pages/welcome.jsx:64
msgid "Log in with Mastodon"
msgstr "Mit Mastodon anmelden"

#: src/pages/welcome.jsx:70
msgid "Sign up"
msgstr "Registrieren"

#: src/pages/welcome.jsx:77
msgid "Connect your existing Mastodon/Fediverse account.<0/>Your credentials are not stored on this server."
msgstr "Verbinden Sie Ihr bestehendes Mastodon/Fediverse Konto.<0/>Ihre Zugangsdaten werden nicht auf diesem Server gespeichert."

#: src/pages/welcome.jsx:94
msgid "<0>Built</0> by <1>@cheeaun</1>. <2>Privacy Policy</2>."
msgstr "<0>Entwickelt</0> von <1>@cheeaun</1>. <2>Datenschutzerklärung</2>."

#: src/pages/welcome.jsx:125
msgid "Screenshot of Boosts Carousel"
msgstr "Bildschirmfoto des Boosts-Karussells"

#: src/pages/welcome.jsx:129
msgid "Boosts Carousel"
msgstr "Boost Karussell"

#: src/pages/welcome.jsx:132
msgid "Visually separate original posts and re-shared posts (boosted posts)."
msgstr "Originelle Posts und erneut geteilte (geboostete) Posts visuell trennen."

#: src/pages/welcome.jsx:141
msgid "Screenshot of nested comments thread"
msgstr "Screenshot von verschachtelten Kommentar-Threads"

#: src/pages/welcome.jsx:145
msgid "Nested comments thread"
msgstr "Verschachtelte Kommentar-Threads"

#: src/pages/welcome.jsx:148
msgid "Effortlessly follow conversations. Semi-collapsible replies."
msgstr "Folge Unterhaltungen mühelos. Halb einklappbare Antworten."

#: src/pages/welcome.jsx:156
msgid "Screenshot of grouped notifications"
msgstr "Screenshot von gruppierten Benachrichtigungen"

#: src/pages/welcome.jsx:160
msgid "Grouped notifications"
msgstr "Gruppierte Benachrichtigungen"

#: src/pages/welcome.jsx:163
msgid "Similar notifications are grouped and collapsed to reduce clutter."
msgstr "Ähnliche Benachrichtigungen werden gruppiert und für mehr Übersichtlichkeit eingeklappt."

#: src/pages/welcome.jsx:172
msgid "Screenshot of multi-column UI"
msgstr "Screenshot der mehrspaltigen Benutzeroberfläche"

#: src/pages/welcome.jsx:176
msgid "Single or multi-column"
msgstr "Einzelne oder mehrere Spalten"

#: src/pages/welcome.jsx:179
msgid "By default, single column for zen-mode seekers. Configurable multi-column for power users."
msgstr "Standardmäßig eine einzelne Spalte für Zen-Modus-Enthusiasten. Konfigurierbares Mehrspalten-Layout für Power-Nutzer."

#: src/pages/welcome.jsx:188
msgid "Screenshot of multi-hashtag timeline with a form to add more hashtags"
msgstr "Bildschirmfoto einer Timeline mehrerer Hashtags mit einem Formular zum Hinzufügen weiterer Hashtags"

#: src/pages/welcome.jsx:192
msgid "Multi-hashtag timeline"
msgstr "Timeline mehrerer Hashtags"

#: src/pages/welcome.jsx:195
msgid "Up to 5 hashtags combined into a single timeline."
msgstr "Bis zu 5 Hashtags, kombiniert in eine gemeinsame Timeline."

#: src/utils/open-compose.js:24
msgid "Looks like your browser is blocking popups."
msgstr "Anscheinend blockiert Ihr Browser Popups."

#: src/utils/show-compose.js:16
msgid "A draft post is currently minimized. Post or discard it before creating a new one."
msgstr "Ein Beitragsentwurf ist derzeit minimiert. Posten oder verwerfen Sie ihn, bevor Sie einen neuen erstellen."

#: src/utils/show-compose.js:21
msgid "A post is currently open. Post or discard it before creating a new one."
msgstr "Ein Beitrag ist derzeit offen. Posten oder verwerfen Sie ihn, bevor Sie einen neuen erstellen."

